// this file is auto-generated based on the entityDefinition.json files
// any changes need to be made to those files, or to the script that generates this file
import * as Entities from "~/Generated/Entities";
import { ODataParameter, useDeleteModel, useGetModel, useGetModels, useUpdateModel } from "~/Hooks/Api/OData";

export const useGetAdminActionConfigurations = (parameter?: ODataParameter) => {
    return useGetModels<Entities.AdminActionConfiguration>(parameter, "adminActionConfigurations");
};
export const useGetAdminActionConfiguration = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.AdminActionConfiguration>(id, parameter, "adminActionConfigurations");
};
export const useUpdateAdminActionConfiguration = () => {
    return useUpdateModel<Entities.AdminActionConfiguration>("adminActionConfigurations");
};
export const useDeleteAdminActionConfiguration = () => {
    return useDeleteModel<Entities.AdminActionConfiguration>("adminActionConfigurations");
};
export const useGetAdminActionPermissions = (parameter?: ODataParameter) => {
    return useGetModels<Entities.AdminActionPermission>(parameter, "adminActionPermissions");
};
export const useGetAdminActionPermission = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.AdminActionPermission>(id, parameter, "adminActionPermissions");
};
export const useUpdateAdminActionPermission = () => {
    return useUpdateModel<Entities.AdminActionPermission>("adminActionPermissions");
};
export const useDeleteAdminActionPermission = () => {
    return useDeleteModel<Entities.AdminActionPermission>("adminActionPermissions");
};
export const useGetAdminUserProfiles = (parameter?: ODataParameter) => {
    return useGetModels<Entities.AdminUserProfile>(parameter, "adminUserProfiles");
};
export const useGetAdminUserProfile = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.AdminUserProfile>(id, parameter, "adminUserProfiles");
};
export const useUpdateAdminUserProfile = () => {
    return useUpdateModel<Entities.AdminUserProfile>("adminUserProfiles");
};
export const useDeleteAdminUserProfile = () => {
    return useDeleteModel<Entities.AdminUserProfile>("adminUserProfiles");
};
export const useGetAdminUserProfilePasswords = (parameter?: ODataParameter) => {
    return useGetModels<Entities.AdminUserProfilePassword>(parameter, "adminUserProfilePasswords");
};
export const useGetAdminUserProfilePassword = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.AdminUserProfilePassword>(id, parameter, "adminUserProfilePasswords");
};
export const useUpdateAdminUserProfilePassword = () => {
    return useUpdateModel<Entities.AdminUserProfilePassword>("adminUserProfilePasswords");
};
export const useDeleteAdminUserProfilePassword = () => {
    return useDeleteModel<Entities.AdminUserProfilePassword>("adminUserProfilePasswords");
};
export const useGetAdminUserProfilePreferences = (parameter?: ODataParameter) => {
    return useGetModels<Entities.AdminUserProfilePreference>(parameter, "adminUserProfilePreferences");
};
export const useGetAdminUserProfilePreference = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.AdminUserProfilePreference>(id, parameter, "adminUserProfilePreferences");
};
export const useUpdateAdminUserProfilePreference = () => {
    return useUpdateModel<Entities.AdminUserProfilePreference>("adminUserProfilePreferences");
};
export const useDeleteAdminUserProfilePreference = () => {
    return useDeleteModel<Entities.AdminUserProfilePreference>("adminUserProfilePreferences");
};
export const useGetAffiliates = (parameter?: ODataParameter) => {
    return useGetModels<Entities.Affiliate>(parameter, "affiliates");
};
export const useGetAffiliate = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.Affiliate>(id, parameter, "affiliates");
};
export const useUpdateAffiliate = () => {
    return useUpdateModel<Entities.Affiliate>("affiliates");
};
export const useDeleteAffiliate = () => {
    return useDeleteModel<Entities.Affiliate>("affiliates");
};
export const useGetApplicationEsLogs = (parameter?: ODataParameter) => {
    return useGetModels<Entities.ApplicationEsLog>(parameter, "applicationEsLogs");
};
export const useGetApplicationEsLog = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.ApplicationEsLog>(id, parameter, "applicationEsLogs");
};
export const useUpdateApplicationEsLog = () => {
    return useUpdateModel<Entities.ApplicationEsLog>("applicationEsLogs");
};
export const useDeleteApplicationEsLog = () => {
    return useDeleteModel<Entities.ApplicationEsLog>("applicationEsLogs");
};
export const useGetApplicationLogs = (parameter?: ODataParameter) => {
    return useGetModels<Entities.ApplicationLog>(parameter, "applicationLogs");
};
export const useGetApplicationLog = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.ApplicationLog>(id, parameter, "applicationLogs");
};
export const useUpdateApplicationLog = () => {
    return useUpdateModel<Entities.ApplicationLog>("applicationLogs");
};
export const useDeleteApplicationLog = () => {
    return useDeleteModel<Entities.ApplicationLog>("applicationLogs");
};
export const useGetApplicationMessages = (parameter?: ODataParameter) => {
    return useGetModels<Entities.ApplicationMessage>(parameter, "applicationMessages");
};
export const useGetApplicationMessage = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.ApplicationMessage>(id, parameter, "applicationMessages");
};
export const useUpdateApplicationMessage = () => {
    return useUpdateModel<Entities.ApplicationMessage>("applicationMessages");
};
export const useDeleteApplicationMessage = () => {
    return useDeleteModel<Entities.ApplicationMessage>("applicationMessages");
};
export const useGetAttributeTypes = (parameter?: ODataParameter) => {
    return useGetModels<Entities.AttributeType>(parameter, "attributeTypes");
};
export const useGetAttributeType = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.AttributeType>(id, parameter, "attributeTypes");
};
export const useUpdateAttributeType = () => {
    return useUpdateModel<Entities.AttributeType>("attributeTypes");
};
export const useDeleteAttributeType = () => {
    return useDeleteModel<Entities.AttributeType>("attributeTypes");
};
export const useGetAttributeValues = (parameter?: ODataParameter) => {
    return useGetModels<Entities.AttributeValue>(parameter, "attributeValues");
};
export const useGetAttributeValue = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.AttributeValue>(id, parameter, "attributeValues");
};
export const useUpdateAttributeValue = () => {
    return useUpdateModel<Entities.AttributeValue>("attributeValues");
};
export const useDeleteAttributeValue = () => {
    return useDeleteModel<Entities.AttributeValue>("attributeValues");
};
export const useGetAudits = (parameter?: ODataParameter) => {
    return useGetModels<Entities.Audit>(parameter, "audits");
};
export const useGetAudit = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.Audit>(id, parameter, "audits");
};
export const useUpdateAudit = () => {
    return useUpdateModel<Entities.Audit>("audits");
};
export const useDeleteAudit = () => {
    return useDeleteModel<Entities.Audit>("audits");
};
export const useGetBadges = (parameter?: ODataParameter) => {
    return useGetModels<Entities.Badge>(parameter, "badges");
};
export const useGetBadge = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.Badge>(id, parameter, "badges");
};
export const useUpdateBadge = () => {
    return useUpdateModel<Entities.Badge>("badges");
};
export const useDeleteBadge = () => {
    return useDeleteModel<Entities.Badge>("badges");
};
export const useGetBadgeAttributeValues = (parameter?: ODataParameter) => {
    return useGetModels<Entities.BadgeAttributeValue>(parameter, "badgeAttributeValues");
};
export const useGetBadgeAttributeValue = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.BadgeAttributeValue>(id, parameter, "badgeAttributeValues");
};
export const useUpdateBadgeAttributeValue = () => {
    return useUpdateModel<Entities.BadgeAttributeValue>("badgeAttributeValues");
};
export const useDeleteBadgeAttributeValue = () => {
    return useDeleteModel<Entities.BadgeAttributeValue>("badgeAttributeValues");
};
export const useGetBadgeProducts = (parameter?: ODataParameter) => {
    return useGetModels<Entities.BadgeProduct>(parameter, "badgeProducts");
};
export const useGetBadgeProduct = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.BadgeProduct>(id, parameter, "badgeProducts");
};
export const useUpdateBadgeProduct = () => {
    return useUpdateModel<Entities.BadgeProduct>("badgeProducts");
};
export const useDeleteBadgeProduct = () => {
    return useDeleteModel<Entities.BadgeProduct>("badgeProducts");
};
export const useGetBillToAddressFields = (parameter?: ODataParameter) => {
    return useGetModels<Entities.BillToAddressField>(parameter, "billToAddressFields");
};
export const useGetBillToAddressField = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.BillToAddressField>(id, parameter, "billToAddressFields");
};
export const useUpdateBillToAddressField = () => {
    return useUpdateModel<Entities.BillToAddressField>("billToAddressFields");
};
export const useDeleteBillToAddressField = () => {
    return useDeleteModel<Entities.BillToAddressField>("billToAddressFields");
};
export const useGetBrands = (parameter?: ODataParameter) => {
    return useGetModels<Entities.Brand>(parameter, "brands");
};
export const useGetBrand = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.Brand>(id, parameter, "brands");
};
export const useUpdateBrand = () => {
    return useUpdateModel<Entities.Brand>("brands");
};
export const useDeleteBrand = () => {
    return useDeleteModel<Entities.Brand>("brands");
};
export const useGetBrandCategoryImages = (parameter?: ODataParameter) => {
    return useGetModels<Entities.BrandCategoryImage>(parameter, "brandCategoryImages");
};
export const useGetBrandCategoryImage = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.BrandCategoryImage>(id, parameter, "brandCategoryImages");
};
export const useUpdateBrandCategoryImage = () => {
    return useUpdateModel<Entities.BrandCategoryImage>("brandCategoryImages");
};
export const useDeleteBrandCategoryImage = () => {
    return useDeleteModel<Entities.BrandCategoryImage>("brandCategoryImages");
};
export const useGetBudgetCalendars = (parameter?: ODataParameter) => {
    return useGetModels<Entities.BudgetCalendar>(parameter, "budgetCalendars");
};
export const useGetBudgetCalendar = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.BudgetCalendar>(id, parameter, "budgetCalendars");
};
export const useUpdateBudgetCalendar = () => {
    return useUpdateModel<Entities.BudgetCalendar>("budgetCalendars");
};
export const useDeleteBudgetCalendar = () => {
    return useDeleteModel<Entities.BudgetCalendar>("budgetCalendars");
};
export const useGetCarriers = (parameter?: ODataParameter) => {
    return useGetModels<Entities.Carrier>(parameter, "carriers");
};
export const useGetCarrier = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.Carrier>(id, parameter, "carriers");
};
export const useUpdateCarrier = () => {
    return useUpdateModel<Entities.Carrier>("carriers");
};
export const useDeleteCarrier = () => {
    return useDeleteModel<Entities.Carrier>("carriers");
};
export const useGetCarrierPackages = (parameter?: ODataParameter) => {
    return useGetModels<Entities.CarrierPackage>(parameter, "carrierPackages");
};
export const useGetCarrierPackage = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.CarrierPackage>(id, parameter, "carrierPackages");
};
export const useUpdateCarrierPackage = () => {
    return useUpdateModel<Entities.CarrierPackage>("carrierPackages");
};
export const useDeleteCarrierPackage = () => {
    return useDeleteModel<Entities.CarrierPackage>("carrierPackages");
};
export const useGetCarrierZones = (parameter?: ODataParameter) => {
    return useGetModels<Entities.CarrierZone>(parameter, "carrierZones");
};
export const useGetCarrierZone = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.CarrierZone>(id, parameter, "carrierZones");
};
export const useUpdateCarrierZone = () => {
    return useUpdateModel<Entities.CarrierZone>("carrierZones");
};
export const useDeleteCarrierZone = () => {
    return useDeleteModel<Entities.CarrierZone>("carrierZones");
};
export const useGetCarrierZonePostalCodeRanges = (parameter?: ODataParameter) => {
    return useGetModels<Entities.CarrierZonePostalCodeRange>(parameter, "carrierZonePostalCodeRanges");
};
export const useGetCarrierZonePostalCodeRange = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.CarrierZonePostalCodeRange>(id, parameter, "carrierZonePostalCodeRanges");
};
export const useUpdateCarrierZonePostalCodeRange = () => {
    return useUpdateModel<Entities.CarrierZonePostalCodeRange>("carrierZonePostalCodeRanges");
};
export const useDeleteCarrierZonePostalCodeRange = () => {
    return useDeleteModel<Entities.CarrierZonePostalCodeRange>("carrierZonePostalCodeRanges");
};
export const useGetCarrierZoneRates = (parameter?: ODataParameter) => {
    return useGetModels<Entities.CarrierZoneRate>(parameter, "carrierZoneRates");
};
export const useGetCarrierZoneRate = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.CarrierZoneRate>(id, parameter, "carrierZoneRates");
};
export const useUpdateCarrierZoneRate = () => {
    return useUpdateModel<Entities.CarrierZoneRate>("carrierZoneRates");
};
export const useDeleteCarrierZoneRate = () => {
    return useDeleteModel<Entities.CarrierZoneRate>("carrierZoneRates");
};
export const useGetCategories = (parameter?: ODataParameter) => {
    return useGetModels<Entities.Category>(parameter, "categories");
};
export const useGetCategory = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.Category>(id, parameter, "categories");
};
export const useUpdateCategory = () => {
    return useUpdateModel<Entities.Category>("categories");
};
export const useDeleteCategory = () => {
    return useDeleteModel<Entities.Category>("categories");
};
export const useGetCategoryAttributeTypes = (parameter?: ODataParameter) => {
    return useGetModels<Entities.CategoryAttributeType>(parameter, "categoryAttributeTypes");
};
export const useGetCategoryAttributeType = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.CategoryAttributeType>(id, parameter, "categoryAttributeTypes");
};
export const useUpdateCategoryAttributeType = () => {
    return useUpdateModel<Entities.CategoryAttributeType>("categoryAttributeTypes");
};
export const useDeleteCategoryAttributeType = () => {
    return useDeleteModel<Entities.CategoryAttributeType>("categoryAttributeTypes");
};
export const useGetCategoryAttributeValues = (parameter?: ODataParameter) => {
    return useGetModels<Entities.CategoryAttributeValue>(parameter, "categoryAttributeValues");
};
export const useGetCategoryAttributeValue = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.CategoryAttributeValue>(id, parameter, "categoryAttributeValues");
};
export const useUpdateCategoryAttributeValue = () => {
    return useUpdateModel<Entities.CategoryAttributeValue>("categoryAttributeValues");
};
export const useDeleteCategoryAttributeValue = () => {
    return useDeleteModel<Entities.CategoryAttributeValue>("categoryAttributeValues");
};
export const useGetCategoryPersonas = (parameter?: ODataParameter) => {
    return useGetModels<Entities.CategoryPersona>(parameter, "categoryPersonas");
};
export const useGetCategoryPersona = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.CategoryPersona>(id, parameter, "categoryPersonas");
};
export const useUpdateCategoryPersona = () => {
    return useUpdateModel<Entities.CategoryPersona>("categoryPersonas");
};
export const useDeleteCategoryPersona = () => {
    return useDeleteModel<Entities.CategoryPersona>("categoryPersonas");
};
export const useGetCategoryPersonaExtendeds = (parameter?: ODataParameter) => {
    return useGetModels<Entities.CategoryPersonaExtended>(parameter, "categoryPersonaExtendeds");
};
export const useGetCategoryPersonaExtended = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.CategoryPersonaExtended>(id, parameter, "categoryPersonaExtendeds");
};
export const useUpdateCategoryPersonaExtended = () => {
    return useUpdateModel<Entities.CategoryPersonaExtended>("categoryPersonaExtendeds");
};
export const useDeleteCategoryPersonaExtended = () => {
    return useDeleteModel<Entities.CategoryPersonaExtended>("categoryPersonaExtendeds");
};
export const useGetCategoryProducts = (parameter?: ODataParameter) => {
    return useGetModels<Entities.CategoryProduct>(parameter, "categoryProducts");
};
export const useGetCategoryProduct = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.CategoryProduct>(id, parameter, "categoryProducts");
};
export const useUpdateCategoryProduct = () => {
    return useUpdateModel<Entities.CategoryProduct>("categoryProducts");
};
export const useDeleteCategoryProduct = () => {
    return useDeleteModel<Entities.CategoryProduct>("categoryProducts");
};
export const useGetCategoryRelatedProducts = (parameter?: ODataParameter) => {
    return useGetModels<Entities.CategoryRelatedProduct>(parameter, "categoryRelatedProducts");
};
export const useGetCategoryRelatedProduct = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.CategoryRelatedProduct>(id, parameter, "categoryRelatedProducts");
};
export const useUpdateCategoryRelatedProduct = () => {
    return useUpdateModel<Entities.CategoryRelatedProduct>("categoryRelatedProducts");
};
export const useDeleteCategoryRelatedProduct = () => {
    return useDeleteModel<Entities.CategoryRelatedProduct>("categoryRelatedProducts");
};
export const useGetCategoryTaxExemptions = (parameter?: ODataParameter) => {
    return useGetModels<Entities.CategoryTaxExemption>(parameter, "categoryTaxExemptions");
};
export const useGetCategoryTaxExemption = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.CategoryTaxExemption>(id, parameter, "categoryTaxExemptions");
};
export const useUpdateCategoryTaxExemption = () => {
    return useUpdateModel<Entities.CategoryTaxExemption>("categoryTaxExemptions");
};
export const useDeleteCategoryTaxExemption = () => {
    return useDeleteModel<Entities.CategoryTaxExemption>("categoryTaxExemptions");
};
export const useGetContents = (parameter?: ODataParameter) => {
    return useGetModels<Entities.Content>(parameter, "contents");
};
export const useGetContent = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.Content>(id, parameter, "contents");
};
export const useUpdateContent = () => {
    return useUpdateModel<Entities.Content>("contents");
};
export const useDeleteContent = () => {
    return useDeleteModel<Entities.Content>("contents");
};
export const useGetContentItems = (parameter?: ODataParameter) => {
    return useGetModels<Entities.ContentItem>(parameter, "contentItems");
};
export const useGetContentItem = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.ContentItem>(id, parameter, "contentItems");
};
export const useUpdateContentItem = () => {
    return useUpdateModel<Entities.ContentItem>("contentItems");
};
export const useDeleteContentItem = () => {
    return useDeleteModel<Entities.ContentItem>("contentItems");
};
export const useGetContentItemFields = (parameter?: ODataParameter) => {
    return useGetModels<Entities.ContentItemField>(parameter, "contentItemFields");
};
export const useGetContentItemField = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.ContentItemField>(id, parameter, "contentItemFields");
};
export const useUpdateContentItemField = () => {
    return useUpdateModel<Entities.ContentItemField>("contentItemFields");
};
export const useDeleteContentItemField = () => {
    return useDeleteModel<Entities.ContentItemField>("contentItemFields");
};
export const useGetContentManagers = (parameter?: ODataParameter) => {
    return useGetModels<Entities.ContentManager>(parameter, "contentManagers");
};
export const useGetContentManager = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.ContentManager>(id, parameter, "contentManagers");
};
export const useUpdateContentManager = () => {
    return useUpdateModel<Entities.ContentManager>("contentManagers");
};
export const useDeleteContentManager = () => {
    return useDeleteModel<Entities.ContentManager>("contentManagers");
};
export const useGetContentPageStates = (parameter?: ODataParameter) => {
    return useGetModels<Entities.ContentPageState>(parameter, "contentPageStates");
};
export const useGetContentPageState = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.ContentPageState>(id, parameter, "contentPageStates");
};
export const useUpdateContentPageState = () => {
    return useUpdateModel<Entities.ContentPageState>("contentPageStates");
};
export const useDeleteContentPageState = () => {
    return useDeleteModel<Entities.ContentPageState>("contentPageStates");
};
export const useGetCountries = (parameter?: ODataParameter) => {
    return useGetModels<Entities.Country>(parameter, "countries");
};
export const useGetCountry = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.Country>(id, parameter, "countries");
};
export const useUpdateCountry = () => {
    return useUpdateModel<Entities.Country>("countries");
};
export const useDeleteCountry = () => {
    return useDeleteModel<Entities.Country>("countries");
};
export const useGetCountryVatRates = (parameter?: ODataParameter) => {
    return useGetModels<Entities.CountryVatRate>(parameter, "countryVatRates");
};
export const useGetCountryVatRate = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.CountryVatRate>(id, parameter, "countryVatRates");
};
export const useUpdateCountryVatRate = () => {
    return useUpdateModel<Entities.CountryVatRate>("countryVatRates");
};
export const useDeleteCountryVatRate = () => {
    return useDeleteModel<Entities.CountryVatRate>("countryVatRates");
};
export const useGetCreditCardTransactions = (parameter?: ODataParameter) => {
    return useGetModels<Entities.CreditCardTransaction>(parameter, "creditCardTransactions");
};
export const useGetCreditCardTransaction = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.CreditCardTransaction>(id, parameter, "creditCardTransactions");
};
export const useUpdateCreditCardTransaction = () => {
    return useUpdateModel<Entities.CreditCardTransaction>("creditCardTransactions");
};
export const useDeleteCreditCardTransaction = () => {
    return useDeleteModel<Entities.CreditCardTransaction>("creditCardTransactions");
};
export const useGetCurrencies = (parameter?: ODataParameter) => {
    return useGetModels<Entities.Currency>(parameter, "currencies");
};
export const useGetCurrency = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.Currency>(id, parameter, "currencies");
};
export const useUpdateCurrency = () => {
    return useUpdateModel<Entities.Currency>("currencies");
};
export const useDeleteCurrency = () => {
    return useDeleteModel<Entities.Currency>("currencies");
};
export const useGetCurrencyRates = (parameter?: ODataParameter) => {
    return useGetModels<Entities.CurrencyRate>(parameter, "currencyRates");
};
export const useGetCurrencyRate = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.CurrencyRate>(id, parameter, "currencyRates");
};
export const useUpdateCurrencyRate = () => {
    return useUpdateModel<Entities.CurrencyRate>("currencyRates");
};
export const useDeleteCurrencyRate = () => {
    return useDeleteModel<Entities.CurrencyRate>("currencyRates");
};
export const useGetCustomProperties = (parameter?: ODataParameter) => {
    return useGetModels<Entities.CustomProperty>(parameter, "customProperties");
};
export const useGetCustomProperty = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.CustomProperty>(id, parameter, "customProperties");
};
export const useUpdateCustomProperty = () => {
    return useUpdateModel<Entities.CustomProperty>("customProperties");
};
export const useDeleteCustomProperty = () => {
    return useDeleteModel<Entities.CustomProperty>("customProperties");
};
export const useGetCustomers = (parameter?: ODataParameter) => {
    return useGetModels<Entities.Customer>(parameter, "customers");
};
export const useGetCustomer = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.Customer>(id, parameter, "customers");
};
export const useUpdateCustomer = () => {
    return useUpdateModel<Entities.Customer>("customers");
};
export const useDeleteCustomer = () => {
    return useDeleteModel<Entities.Customer>("customers");
};
export const useGetCustomerBudgets = (parameter?: ODataParameter) => {
    return useGetModels<Entities.CustomerBudget>(parameter, "customerBudgets");
};
export const useGetCustomerBudget = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.CustomerBudget>(id, parameter, "customerBudgets");
};
export const useUpdateCustomerBudget = () => {
    return useUpdateModel<Entities.CustomerBudget>("customerBudgets");
};
export const useDeleteCustomerBudget = () => {
    return useDeleteModel<Entities.CustomerBudget>("customerBudgets");
};
export const useGetCustomerCarriers = (parameter?: ODataParameter) => {
    return useGetModels<Entities.CustomerCarrier>(parameter, "customerCarriers");
};
export const useGetCustomerCarrier = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.CustomerCarrier>(id, parameter, "customerCarriers");
};
export const useUpdateCustomerCarrier = () => {
    return useUpdateModel<Entities.CustomerCarrier>("customerCarriers");
};
export const useDeleteCustomerCarrier = () => {
    return useDeleteModel<Entities.CustomerCarrier>("customerCarriers");
};
export const useGetCustomerCostCodes = (parameter?: ODataParameter) => {
    return useGetModels<Entities.CustomerCostCode>(parameter, "customerCostCodes");
};
export const useGetCustomerCostCode = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.CustomerCostCode>(id, parameter, "customerCostCodes");
};
export const useUpdateCustomerCostCode = () => {
    return useUpdateModel<Entities.CustomerCostCode>("customerCostCodes");
};
export const useDeleteCustomerCostCode = () => {
    return useDeleteModel<Entities.CustomerCostCode>("customerCostCodes");
};
export const useGetCustomerOrders = (parameter?: ODataParameter) => {
    return useGetModels<Entities.CustomerOrder>(parameter, "customerOrders");
};
export const useGetCustomerOrder = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.CustomerOrder>(id, parameter, "customerOrders");
};
export const useUpdateCustomerOrder = () => {
    return useUpdateModel<Entities.CustomerOrder>("customerOrders");
};
export const useDeleteCustomerOrder = () => {
    return useDeleteModel<Entities.CustomerOrder>("customerOrders");
};
export const useGetCustomerOrderGiftCards = (parameter?: ODataParameter) => {
    return useGetModels<Entities.CustomerOrderGiftCard>(parameter, "customerOrderGiftCards");
};
export const useGetCustomerOrderGiftCard = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.CustomerOrderGiftCard>(id, parameter, "customerOrderGiftCards");
};
export const useUpdateCustomerOrderGiftCard = () => {
    return useUpdateModel<Entities.CustomerOrderGiftCard>("customerOrderGiftCards");
};
export const useDeleteCustomerOrderGiftCard = () => {
    return useDeleteModel<Entities.CustomerOrderGiftCard>("customerOrderGiftCards");
};
export const useGetCustomerOrderPromotions = (parameter?: ODataParameter) => {
    return useGetModels<Entities.CustomerOrderPromotion>(parameter, "customerOrderPromotions");
};
export const useGetCustomerOrderPromotion = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.CustomerOrderPromotion>(id, parameter, "customerOrderPromotions");
};
export const useUpdateCustomerOrderPromotion = () => {
    return useUpdateModel<Entities.CustomerOrderPromotion>("customerOrderPromotions");
};
export const useDeleteCustomerOrderPromotion = () => {
    return useDeleteModel<Entities.CustomerOrderPromotion>("customerOrderPromotions");
};
export const useGetCustomerOrderTaxes = (parameter?: ODataParameter) => {
    return useGetModels<Entities.CustomerOrderTax>(parameter, "customerOrderTaxes");
};
export const useGetCustomerOrderTax = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.CustomerOrderTax>(id, parameter, "customerOrderTaxes");
};
export const useUpdateCustomerOrderTax = () => {
    return useUpdateModel<Entities.CustomerOrderTax>("customerOrderTaxes");
};
export const useDeleteCustomerOrderTax = () => {
    return useDeleteModel<Entities.CustomerOrderTax>("customerOrderTaxes");
};
export const useGetCustomerProducts = (parameter?: ODataParameter) => {
    return useGetModels<Entities.CustomerProduct>(parameter, "customerProducts");
};
export const useGetCustomerProduct = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.CustomerProduct>(id, parameter, "customerProducts");
};
export const useUpdateCustomerProduct = () => {
    return useUpdateModel<Entities.CustomerProduct>("customerProducts");
};
export const useDeleteCustomerProduct = () => {
    return useDeleteModel<Entities.CustomerProduct>("customerProducts");
};
export const useGetCustomerProductSets = (parameter?: ODataParameter) => {
    return useGetModels<Entities.CustomerProductSet>(parameter, "customerProductSets");
};
export const useGetCustomerProductSet = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.CustomerProductSet>(id, parameter, "customerProductSets");
};
export const useUpdateCustomerProductSet = () => {
    return useUpdateModel<Entities.CustomerProductSet>("customerProductSets");
};
export const useDeleteCustomerProductSet = () => {
    return useDeleteModel<Entities.CustomerProductSet>("customerProductSets");
};
export const useGetCustomerProductVisibilityAdditions = (parameter?: ODataParameter) => {
    return useGetModels<Entities.CustomerProductVisibilityAddition>(parameter, "customerProductVisibilityAdditions");
};
export const useGetCustomerProductVisibilityAddition = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.CustomerProductVisibilityAddition>(id, parameter, "customerProductVisibilityAdditions");
};
export const useUpdateCustomerProductVisibilityAddition = () => {
    return useUpdateModel<Entities.CustomerProductVisibilityAddition>("customerProductVisibilityAdditions");
};
export const useDeleteCustomerProductVisibilityAddition = () => {
    return useDeleteModel<Entities.CustomerProductVisibilityAddition>("customerProductVisibilityAdditions");
};
export const useGetCustomerProductVisibilityExceptions = (parameter?: ODataParameter) => {
    return useGetModels<Entities.CustomerProductVisibilityException>(parameter, "customerProductVisibilityExceptions");
};
export const useGetCustomerProductVisibilityException = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.CustomerProductVisibilityException>(id, parameter, "customerProductVisibilityExceptions");
};
export const useUpdateCustomerProductVisibilityException = () => {
    return useUpdateModel<Entities.CustomerProductVisibilityException>("customerProductVisibilityExceptions");
};
export const useDeleteCustomerProductVisibilityException = () => {
    return useDeleteModel<Entities.CustomerProductVisibilityException>("customerProductVisibilityExceptions");
};
export const useGetCustomerUserProfiles = (parameter?: ODataParameter) => {
    return useGetModels<Entities.CustomerUserProfile>(parameter, "customerUserProfiles");
};
export const useGetCustomerUserProfile = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.CustomerUserProfile>(id, parameter, "customerUserProfiles");
};
export const useUpdateCustomerUserProfile = () => {
    return useUpdateModel<Entities.CustomerUserProfile>("customerUserProfiles");
};
export const useDeleteCustomerUserProfile = () => {
    return useDeleteModel<Entities.CustomerUserProfile>("customerUserProfiles");
};
export const useGetDashboardPanelPositions = (parameter?: ODataParameter) => {
    return useGetModels<Entities.DashboardPanelPosition>(parameter, "dashboardPanelPositions");
};
export const useGetDashboardPanelPosition = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.DashboardPanelPosition>(id, parameter, "dashboardPanelPositions");
};
export const useUpdateDashboardPanelPosition = () => {
    return useUpdateModel<Entities.DashboardPanelPosition>("dashboardPanelPositions");
};
export const useDeleteDashboardPanelPosition = () => {
    return useDeleteModel<Entities.DashboardPanelPosition>("dashboardPanelPositions");
};
export const useGetDatabaseScripts = (parameter?: ODataParameter) => {
    return useGetModels<Entities.DatabaseScript>(parameter, "databaseScripts");
};
export const useGetDatabaseScript = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.DatabaseScript>(id, parameter, "databaseScripts");
};
export const useUpdateDatabaseScript = () => {
    return useUpdateModel<Entities.DatabaseScript>("databaseScripts");
};
export const useDeleteDatabaseScript = () => {
    return useDeleteModel<Entities.DatabaseScript>("databaseScripts");
};
export const useGetDealers = (parameter?: ODataParameter) => {
    return useGetModels<Entities.Dealer>(parameter, "dealers");
};
export const useGetDealer = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.Dealer>(id, parameter, "dealers");
};
export const useUpdateDealer = () => {
    return useUpdateModel<Entities.Dealer>("dealers");
};
export const useDeleteDealer = () => {
    return useDeleteModel<Entities.Dealer>("dealers");
};
export const useGetDealerCategories = (parameter?: ODataParameter) => {
    return useGetModels<Entities.DealerCategory>(parameter, "dealerCategories");
};
export const useGetDealerCategory = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.DealerCategory>(id, parameter, "dealerCategories");
};
export const useUpdateDealerCategory = () => {
    return useUpdateModel<Entities.DealerCategory>("dealerCategories");
};
export const useDeleteDealerCategory = () => {
    return useDeleteModel<Entities.DealerCategory>("dealerCategories");
};
export const useGetDealerProducts = (parameter?: ODataParameter) => {
    return useGetModels<Entities.DealerProduct>(parameter, "dealerProducts");
};
export const useGetDealerProduct = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.DealerProduct>(id, parameter, "dealerProducts");
};
export const useUpdateDealerProduct = () => {
    return useUpdateModel<Entities.DealerProduct>("dealerProducts");
};
export const useDeleteDealerProduct = () => {
    return useDeleteModel<Entities.DealerProduct>("dealerProducts");
};
export const useGetDocuments = (parameter?: ODataParameter) => {
    return useGetModels<Entities.Document>(parameter, "documents");
};
export const useGetDocument = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.Document>(id, parameter, "documents");
};
export const useUpdateDocument = () => {
    return useUpdateModel<Entities.Document>("documents");
};
export const useDeleteDocument = () => {
    return useDeleteModel<Entities.Document>("documents");
};
export const useGetEmailLists = (parameter?: ODataParameter) => {
    return useGetModels<Entities.EmailList>(parameter, "emailLists");
};
export const useGetEmailList = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.EmailList>(id, parameter, "emailLists");
};
export const useUpdateEmailList = () => {
    return useUpdateModel<Entities.EmailList>("emailLists");
};
export const useDeleteEmailList = () => {
    return useDeleteModel<Entities.EmailList>("emailLists");
};
export const useGetEmailMessages = (parameter?: ODataParameter) => {
    return useGetModels<Entities.EmailMessage>(parameter, "emailMessages");
};
export const useGetEmailMessage = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.EmailMessage>(id, parameter, "emailMessages");
};
export const useUpdateEmailMessage = () => {
    return useUpdateModel<Entities.EmailMessage>("emailMessages");
};
export const useDeleteEmailMessage = () => {
    return useDeleteModel<Entities.EmailMessage>("emailMessages");
};
export const useGetEmailMessageAddresses = (parameter?: ODataParameter) => {
    return useGetModels<Entities.EmailMessageAddress>(parameter, "emailMessageAddresses");
};
export const useGetEmailMessageAddress = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.EmailMessageAddress>(id, parameter, "emailMessageAddresses");
};
export const useUpdateEmailMessageAddress = () => {
    return useUpdateModel<Entities.EmailMessageAddress>("emailMessageAddresses");
};
export const useDeleteEmailMessageAddress = () => {
    return useDeleteModel<Entities.EmailMessageAddress>("emailMessageAddresses");
};
export const useGetEmailMessageAttachments = (parameter?: ODataParameter) => {
    return useGetModels<Entities.EmailMessageAttachment>(parameter, "emailMessageAttachments");
};
export const useGetEmailMessageAttachment = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.EmailMessageAttachment>(id, parameter, "emailMessageAttachments");
};
export const useUpdateEmailMessageAttachment = () => {
    return useUpdateModel<Entities.EmailMessageAttachment>("emailMessageAttachments");
};
export const useDeleteEmailMessageAttachment = () => {
    return useDeleteModel<Entities.EmailMessageAttachment>("emailMessageAttachments");
};
export const useGetEmailMessageDeliveryAttempts = (parameter?: ODataParameter) => {
    return useGetModels<Entities.EmailMessageDeliveryAttempt>(parameter, "emailMessageDeliveryAttempts");
};
export const useGetEmailMessageDeliveryAttempt = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.EmailMessageDeliveryAttempt>(id, parameter, "emailMessageDeliveryAttempts");
};
export const useUpdateEmailMessageDeliveryAttempt = () => {
    return useUpdateModel<Entities.EmailMessageDeliveryAttempt>("emailMessageDeliveryAttempts");
};
export const useDeleteEmailMessageDeliveryAttempt = () => {
    return useDeleteModel<Entities.EmailMessageDeliveryAttempt>("emailMessageDeliveryAttempts");
};
export const useGetEmailSubscribers = (parameter?: ODataParameter) => {
    return useGetModels<Entities.EmailSubscriber>(parameter, "emailSubscribers");
};
export const useGetEmailSubscriber = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.EmailSubscriber>(id, parameter, "emailSubscribers");
};
export const useUpdateEmailSubscriber = () => {
    return useUpdateModel<Entities.EmailSubscriber>("emailSubscribers");
};
export const useDeleteEmailSubscriber = () => {
    return useDeleteModel<Entities.EmailSubscriber>("emailSubscribers");
};
export const useGetEmailSubscriberEmailLists = (parameter?: ODataParameter) => {
    return useGetModels<Entities.EmailSubscriberEmailList>(parameter, "emailSubscriberEmailLists");
};
export const useGetEmailSubscriberEmailList = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.EmailSubscriberEmailList>(id, parameter, "emailSubscriberEmailLists");
};
export const useUpdateEmailSubscriberEmailList = () => {
    return useUpdateModel<Entities.EmailSubscriberEmailList>("emailSubscriberEmailLists");
};
export const useDeleteEmailSubscriberEmailList = () => {
    return useDeleteModel<Entities.EmailSubscriberEmailList>("emailSubscriberEmailLists");
};
export const useGetEmailTemplates = (parameter?: ODataParameter) => {
    return useGetModels<Entities.EmailTemplate>(parameter, "emailTemplates");
};
export const useGetEmailTemplate = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.EmailTemplate>(id, parameter, "emailTemplates");
};
export const useUpdateEmailTemplate = () => {
    return useUpdateModel<Entities.EmailTemplate>("emailTemplates");
};
export const useDeleteEmailTemplate = () => {
    return useDeleteModel<Entities.EmailTemplate>("emailTemplates");
};
export const useGetEntityConfigurations = (parameter?: ODataParameter) => {
    return useGetModels<Entities.EntityConfiguration>(parameter, "entityConfigurations");
};
export const useGetEntityConfiguration = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.EntityConfiguration>(id, parameter, "entityConfigurations");
};
export const useUpdateEntityConfiguration = () => {
    return useUpdateModel<Entities.EntityConfiguration>("entityConfigurations");
};
export const useDeleteEntityConfiguration = () => {
    return useDeleteModel<Entities.EntityConfiguration>("entityConfigurations");
};
export const useGetEntityPermissions = (parameter?: ODataParameter) => {
    return useGetModels<Entities.EntityPermission>(parameter, "entityPermissions");
};
export const useGetEntityPermission = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.EntityPermission>(id, parameter, "entityPermissions");
};
export const useUpdateEntityPermission = () => {
    return useUpdateModel<Entities.EntityPermission>("entityPermissions");
};
export const useDeleteEntityPermission = () => {
    return useDeleteModel<Entities.EntityPermission>("entityPermissions");
};
export const useGetExperiments = (parameter?: ODataParameter) => {
    return useGetModels<Entities.Experiment>(parameter, "experiments");
};
export const useGetExperiment = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.Experiment>(id, parameter, "experiments");
};
export const useUpdateExperiment = () => {
    return useUpdateModel<Entities.Experiment>("experiments");
};
export const useDeleteExperiment = () => {
    return useDeleteModel<Entities.Experiment>("experiments");
};
export const useGetExperimentParticipants = (parameter?: ODataParameter) => {
    return useGetModels<Entities.ExperimentParticipant>(parameter, "experimentParticipants");
};
export const useGetExperimentParticipant = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.ExperimentParticipant>(id, parameter, "experimentParticipants");
};
export const useUpdateExperimentParticipant = () => {
    return useUpdateModel<Entities.ExperimentParticipant>("experimentParticipants");
};
export const useDeleteExperimentParticipant = () => {
    return useDeleteModel<Entities.ExperimentParticipant>("experimentParticipants");
};
export const useGetGiftCards = (parameter?: ODataParameter) => {
    return useGetModels<Entities.GiftCard>(parameter, "giftCards");
};
export const useGetGiftCard = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.GiftCard>(id, parameter, "giftCards");
};
export const useUpdateGiftCard = () => {
    return useUpdateModel<Entities.GiftCard>("giftCards");
};
export const useDeleteGiftCard = () => {
    return useDeleteModel<Entities.GiftCard>("giftCards");
};
export const useGetGiftCardTransactions = (parameter?: ODataParameter) => {
    return useGetModels<Entities.GiftCardTransaction>(parameter, "giftCardTransactions");
};
export const useGetGiftCardTransaction = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.GiftCardTransaction>(id, parameter, "giftCardTransactions");
};
export const useUpdateGiftCardTransaction = () => {
    return useUpdateModel<Entities.GiftCardTransaction>("giftCardTransactions");
};
export const useDeleteGiftCardTransaction = () => {
    return useDeleteModel<Entities.GiftCardTransaction>("giftCardTransactions");
};
export const useGetGlobalSynonyms = (parameter?: ODataParameter) => {
    return useGetModels<Entities.GlobalSynonym>(parameter, "globalSynonyms");
};
export const useGetGlobalSynonym = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.GlobalSynonym>(id, parameter, "globalSynonyms");
};
export const useUpdateGlobalSynonym = () => {
    return useUpdateModel<Entities.GlobalSynonym>("globalSynonyms");
};
export const useDeleteGlobalSynonym = () => {
    return useDeleteModel<Entities.GlobalSynonym>("globalSynonyms");
};
export const useGetHtmlRedirects = (parameter?: ODataParameter) => {
    return useGetModels<Entities.HtmlRedirect>(parameter, "htmlRedirects");
};
export const useGetHtmlRedirect = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.HtmlRedirect>(id, parameter, "htmlRedirects");
};
export const useUpdateHtmlRedirect = () => {
    return useUpdateModel<Entities.HtmlRedirect>("htmlRedirects");
};
export const useDeleteHtmlRedirect = () => {
    return useDeleteModel<Entities.HtmlRedirect>("htmlRedirects");
};
export const useGetIntegrationConnections = (parameter?: ODataParameter) => {
    return useGetModels<Entities.IntegrationConnection>(parameter, "integrationConnections");
};
export const useGetIntegrationConnection = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.IntegrationConnection>(id, parameter, "integrationConnections");
};
export const useUpdateIntegrationConnection = () => {
    return useUpdateModel<Entities.IntegrationConnection>("integrationConnections");
};
export const useDeleteIntegrationConnection = () => {
    return useDeleteModel<Entities.IntegrationConnection>("integrationConnections");
};
export const useGetIntegrationJobs = (parameter?: ODataParameter) => {
    return useGetModels<Entities.IntegrationJob>(parameter, "integrationJobs");
};
export const useGetIntegrationJob = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.IntegrationJob>(id, parameter, "integrationJobs");
};
export const useUpdateIntegrationJob = () => {
    return useUpdateModel<Entities.IntegrationJob>("integrationJobs");
};
export const useDeleteIntegrationJob = () => {
    return useDeleteModel<Entities.IntegrationJob>("integrationJobs");
};
export const useGetIntegrationJobEsLogs = (parameter?: ODataParameter) => {
    return useGetModels<Entities.IntegrationJobEsLog>(parameter, "integrationJobEsLogs");
};
export const useGetIntegrationJobEsLog = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.IntegrationJobEsLog>(id, parameter, "integrationJobEsLogs");
};
export const useUpdateIntegrationJobEsLog = () => {
    return useUpdateModel<Entities.IntegrationJobEsLog>("integrationJobEsLogs");
};
export const useDeleteIntegrationJobEsLog = () => {
    return useDeleteModel<Entities.IntegrationJobEsLog>("integrationJobEsLogs");
};
export const useGetIntegrationJobLogs = (parameter?: ODataParameter) => {
    return useGetModels<Entities.IntegrationJobLog>(parameter, "integrationJobLogs");
};
export const useGetIntegrationJobLog = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.IntegrationJobLog>(id, parameter, "integrationJobLogs");
};
export const useUpdateIntegrationJobLog = () => {
    return useUpdateModel<Entities.IntegrationJobLog>("integrationJobLogs");
};
export const useDeleteIntegrationJobLog = () => {
    return useDeleteModel<Entities.IntegrationJobLog>("integrationJobLogs");
};
export const useGetIntegrationJobParameters = (parameter?: ODataParameter) => {
    return useGetModels<Entities.IntegrationJobParameter>(parameter, "integrationJobParameters");
};
export const useGetIntegrationJobParameter = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.IntegrationJobParameter>(id, parameter, "integrationJobParameters");
};
export const useUpdateIntegrationJobParameter = () => {
    return useUpdateModel<Entities.IntegrationJobParameter>("integrationJobParameters");
};
export const useDeleteIntegrationJobParameter = () => {
    return useDeleteModel<Entities.IntegrationJobParameter>("integrationJobParameters");
};
export const useGetInvoiceHistories = (parameter?: ODataParameter) => {
    return useGetModels<Entities.InvoiceHistory>(parameter, "invoiceHistories");
};
export const useGetInvoiceHistory = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.InvoiceHistory>(id, parameter, "invoiceHistories");
};
export const useUpdateInvoiceHistory = () => {
    return useUpdateModel<Entities.InvoiceHistory>("invoiceHistories");
};
export const useDeleteInvoiceHistory = () => {
    return useDeleteModel<Entities.InvoiceHistory>("invoiceHistories");
};
export const useGetInvoiceHistoryLines = (parameter?: ODataParameter) => {
    return useGetModels<Entities.InvoiceHistoryLine>(parameter, "invoiceHistoryLines");
};
export const useGetInvoiceHistoryLine = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.InvoiceHistoryLine>(id, parameter, "invoiceHistoryLines");
};
export const useUpdateInvoiceHistoryLine = () => {
    return useUpdateModel<Entities.InvoiceHistoryLine>("invoiceHistoryLines");
};
export const useDeleteInvoiceHistoryLine = () => {
    return useDeleteModel<Entities.InvoiceHistoryLine>("invoiceHistoryLines");
};
export const useGetInvoiceHistoryTaxes = (parameter?: ODataParameter) => {
    return useGetModels<Entities.InvoiceHistoryTax>(parameter, "invoiceHistoryTaxes");
};
export const useGetInvoiceHistoryTax = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.InvoiceHistoryTax>(id, parameter, "invoiceHistoryTaxes");
};
export const useUpdateInvoiceHistoryTax = () => {
    return useUpdateModel<Entities.InvoiceHistoryTax>("invoiceHistoryTaxes");
};
export const useDeleteInvoiceHistoryTax = () => {
    return useDeleteModel<Entities.InvoiceHistoryTax>("invoiceHistoryTaxes");
};
export const useGetJobDefinitions = (parameter?: ODataParameter) => {
    return useGetModels<Entities.JobDefinition>(parameter, "jobDefinitions");
};
export const useGetJobDefinition = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.JobDefinition>(id, parameter, "jobDefinitions");
};
export const useUpdateJobDefinition = () => {
    return useUpdateModel<Entities.JobDefinition>("jobDefinitions");
};
export const useDeleteJobDefinition = () => {
    return useDeleteModel<Entities.JobDefinition>("jobDefinitions");
};
export const useGetJobDefinitionParameters = (parameter?: ODataParameter) => {
    return useGetModels<Entities.JobDefinitionParameter>(parameter, "jobDefinitionParameters");
};
export const useGetJobDefinitionParameter = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.JobDefinitionParameter>(id, parameter, "jobDefinitionParameters");
};
export const useUpdateJobDefinitionParameter = () => {
    return useUpdateModel<Entities.JobDefinitionParameter>("jobDefinitionParameters");
};
export const useDeleteJobDefinitionParameter = () => {
    return useDeleteModel<Entities.JobDefinitionParameter>("jobDefinitionParameters");
};
export const useGetJobDefinitionSteps = (parameter?: ODataParameter) => {
    return useGetModels<Entities.JobDefinitionStep>(parameter, "jobDefinitionSteps");
};
export const useGetJobDefinitionStep = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.JobDefinitionStep>(id, parameter, "jobDefinitionSteps");
};
export const useUpdateJobDefinitionStep = () => {
    return useUpdateModel<Entities.JobDefinitionStep>("jobDefinitionSteps");
};
export const useDeleteJobDefinitionStep = () => {
    return useDeleteModel<Entities.JobDefinitionStep>("jobDefinitionSteps");
};
export const useGetJobDefinitionStepFieldMaps = (parameter?: ODataParameter) => {
    return useGetModels<Entities.JobDefinitionStepFieldMap>(parameter, "jobDefinitionStepFieldMaps");
};
export const useGetJobDefinitionStepFieldMap = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.JobDefinitionStepFieldMap>(id, parameter, "jobDefinitionStepFieldMaps");
};
export const useUpdateJobDefinitionStepFieldMap = () => {
    return useUpdateModel<Entities.JobDefinitionStepFieldMap>("jobDefinitionStepFieldMaps");
};
export const useDeleteJobDefinitionStepFieldMap = () => {
    return useDeleteModel<Entities.JobDefinitionStepFieldMap>("jobDefinitionStepFieldMaps");
};
export const useGetJobDefinitionStepParameters = (parameter?: ODataParameter) => {
    return useGetModels<Entities.JobDefinitionStepParameter>(parameter, "jobDefinitionStepParameters");
};
export const useGetJobDefinitionStepParameter = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.JobDefinitionStepParameter>(id, parameter, "jobDefinitionStepParameters");
};
export const useUpdateJobDefinitionStepParameter = () => {
    return useUpdateModel<Entities.JobDefinitionStepParameter>("jobDefinitionStepParameters");
};
export const useDeleteJobDefinitionStepParameter = () => {
    return useDeleteModel<Entities.JobDefinitionStepParameter>("jobDefinitionStepParameters");
};
export const useGetLanguages = (parameter?: ODataParameter) => {
    return useGetModels<Entities.Language>(parameter, "languages");
};
export const useGetLanguage = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.Language>(id, parameter, "languages");
};
export const useUpdateLanguage = () => {
    return useUpdateModel<Entities.Language>("languages");
};
export const useDeleteLanguage = () => {
    return useDeleteModel<Entities.Language>("languages");
};
export const useGetLocalTaxRates = (parameter?: ODataParameter) => {
    return useGetModels<Entities.LocalTaxRate>(parameter, "localTaxRates");
};
export const useGetLocalTaxRate = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.LocalTaxRate>(id, parameter, "localTaxRates");
};
export const useUpdateLocalTaxRate = () => {
    return useUpdateModel<Entities.LocalTaxRate>("localTaxRates");
};
export const useDeleteLocalTaxRate = () => {
    return useDeleteModel<Entities.LocalTaxRate>("localTaxRates");
};
export const useGetLocalTaxRateTaxExemptions = (parameter?: ODataParameter) => {
    return useGetModels<Entities.LocalTaxRateTaxExemption>(parameter, "localTaxRateTaxExemptions");
};
export const useGetLocalTaxRateTaxExemption = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.LocalTaxRateTaxExemption>(id, parameter, "localTaxRateTaxExemptions");
};
export const useUpdateLocalTaxRateTaxExemption = () => {
    return useUpdateModel<Entities.LocalTaxRateTaxExemption>("localTaxRateTaxExemptions");
};
export const useDeleteLocalTaxRateTaxExemption = () => {
    return useDeleteModel<Entities.LocalTaxRateTaxExemption>("localTaxRateTaxExemptions");
};
export const useGetMessages = (parameter?: ODataParameter) => {
    return useGetModels<Entities.Message>(parameter, "messages");
};
export const useGetMessage = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.Message>(id, parameter, "messages");
};
export const useUpdateMessage = () => {
    return useUpdateModel<Entities.Message>("messages");
};
export const useDeleteMessage = () => {
    return useDeleteModel<Entities.Message>("messages");
};
export const useGetMessageAudits = (parameter?: ODataParameter) => {
    return useGetModels<Entities.MessageAudit>(parameter, "messageAudits");
};
export const useGetMessageAudit = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.MessageAudit>(id, parameter, "messageAudits");
};
export const useUpdateMessageAudit = () => {
    return useUpdateModel<Entities.MessageAudit>("messageAudits");
};
export const useDeleteMessageAudit = () => {
    return useDeleteModel<Entities.MessageAudit>("messageAudits");
};
export const useGetMessageStatuses = (parameter?: ODataParameter) => {
    return useGetModels<Entities.MessageStatus>(parameter, "messageStatus");
};
export const useGetMessageStatus = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.MessageStatus>(id, parameter, "messageStatus");
};
export const useUpdateMessageStatus = () => {
    return useUpdateModel<Entities.MessageStatus>("messageStatus");
};
export const useDeleteMessageStatus = () => {
    return useDeleteModel<Entities.MessageStatus>("messageStatus");
};
export const useGetMessageTargets = (parameter?: ODataParameter) => {
    return useGetModels<Entities.MessageTarget>(parameter, "messageTargets");
};
export const useGetMessageTarget = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.MessageTarget>(id, parameter, "messageTargets");
};
export const useUpdateMessageTarget = () => {
    return useUpdateModel<Entities.MessageTarget>("messageTargets");
};
export const useDeleteMessageTarget = () => {
    return useDeleteModel<Entities.MessageTarget>("messageTargets");
};
export const useGetMobiusThemes = (parameter?: ODataParameter) => {
    return useGetModels<Entities.MobiusTheme>(parameter, "mobiusThemes");
};
export const useGetMobiusTheme = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.MobiusTheme>(id, parameter, "mobiusThemes");
};
export const useUpdateMobiusTheme = () => {
    return useUpdateModel<Entities.MobiusTheme>("mobiusThemes");
};
export const useDeleteMobiusTheme = () => {
    return useDeleteModel<Entities.MobiusTheme>("mobiusThemes");
};
export const useGetNodes = (parameter?: ODataParameter) => {
    return useGetModels<Entities.Node>(parameter, "nodes");
};
export const useGetNode = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.Node>(id, parameter, "nodes");
};
export const useUpdateNode = () => {
    return useUpdateModel<Entities.Node>("nodes");
};
export const useDeleteNode = () => {
    return useDeleteModel<Entities.Node>("nodes");
};
export const useGetOrderHistories = (parameter?: ODataParameter) => {
    return useGetModels<Entities.OrderHistory>(parameter, "orderHistories");
};
export const useGetOrderHistory = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.OrderHistory>(id, parameter, "orderHistories");
};
export const useUpdateOrderHistory = () => {
    return useUpdateModel<Entities.OrderHistory>("orderHistories");
};
export const useDeleteOrderHistory = () => {
    return useDeleteModel<Entities.OrderHistory>("orderHistories");
};
export const useGetOrderHistoryLines = (parameter?: ODataParameter) => {
    return useGetModels<Entities.OrderHistoryLine>(parameter, "orderHistoryLines");
};
export const useGetOrderHistoryLine = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.OrderHistoryLine>(id, parameter, "orderHistoryLines");
};
export const useUpdateOrderHistoryLine = () => {
    return useUpdateModel<Entities.OrderHistoryLine>("orderHistoryLines");
};
export const useDeleteOrderHistoryLine = () => {
    return useDeleteModel<Entities.OrderHistoryLine>("orderHistoryLines");
};
export const useGetOrderHistoryPromotions = (parameter?: ODataParameter) => {
    return useGetModels<Entities.OrderHistoryPromotion>(parameter, "orderHistoryPromotions");
};
export const useGetOrderHistoryPromotion = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.OrderHistoryPromotion>(id, parameter, "orderHistoryPromotions");
};
export const useUpdateOrderHistoryPromotion = () => {
    return useUpdateModel<Entities.OrderHistoryPromotion>("orderHistoryPromotions");
};
export const useDeleteOrderHistoryPromotion = () => {
    return useDeleteModel<Entities.OrderHistoryPromotion>("orderHistoryPromotions");
};
export const useGetOrderHistoryTaxes = (parameter?: ODataParameter) => {
    return useGetModels<Entities.OrderHistoryTax>(parameter, "orderHistoryTaxes");
};
export const useGetOrderHistoryTax = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.OrderHistoryTax>(id, parameter, "orderHistoryTaxes");
};
export const useUpdateOrderHistoryTax = () => {
    return useUpdateModel<Entities.OrderHistoryTax>("orderHistoryTaxes");
};
export const useDeleteOrderHistoryTax = () => {
    return useDeleteModel<Entities.OrderHistoryTax>("orderHistoryTaxes");
};
export const useGetOrderLines = (parameter?: ODataParameter) => {
    return useGetModels<Entities.OrderLine>(parameter, "orderLines");
};
export const useGetOrderLine = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.OrderLine>(id, parameter, "orderLines");
};
export const useUpdateOrderLine = () => {
    return useUpdateModel<Entities.OrderLine>("orderLines");
};
export const useDeleteOrderLine = () => {
    return useDeleteModel<Entities.OrderLine>("orderLines");
};
export const useGetOrderLineRequisitions = (parameter?: ODataParameter) => {
    return useGetModels<Entities.OrderLineRequisition>(parameter, "orderLineRequisitions");
};
export const useGetOrderLineRequisition = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.OrderLineRequisition>(id, parameter, "orderLineRequisitions");
};
export const useUpdateOrderLineRequisition = () => {
    return useUpdateModel<Entities.OrderLineRequisition>("orderLineRequisitions");
};
export const useDeleteOrderLineRequisition = () => {
    return useDeleteModel<Entities.OrderLineRequisition>("orderLineRequisitions");
};
export const useGetOrderLineRfqs = (parameter?: ODataParameter) => {
    return useGetModels<Entities.OrderLineRfq>(parameter, "orderLineRfqs");
};
export const useGetOrderLineRfq = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.OrderLineRfq>(id, parameter, "orderLineRfqs");
};
export const useUpdateOrderLineRfq = () => {
    return useUpdateModel<Entities.OrderLineRfq>("orderLineRfqs");
};
export const useDeleteOrderLineRfq = () => {
    return useDeleteModel<Entities.OrderLineRfq>("orderLineRfqs");
};
export const useGetOrderLineVats = (parameter?: ODataParameter) => {
    return useGetModels<Entities.OrderLineVat>(parameter, "orderLineVats");
};
export const useGetOrderLineVat = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.OrderLineVat>(id, parameter, "orderLineVats");
};
export const useUpdateOrderLineVat = () => {
    return useUpdateModel<Entities.OrderLineVat>("orderLineVats");
};
export const useDeleteOrderLineVat = () => {
    return useDeleteModel<Entities.OrderLineVat>("orderLineVats");
};
export const useGetOrderPromotionCodes = (parameter?: ODataParameter) => {
    return useGetModels<Entities.OrderPromotionCode>(parameter, "orderPromotionCodes");
};
export const useGetOrderPromotionCode = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.OrderPromotionCode>(id, parameter, "orderPromotionCodes");
};
export const useUpdateOrderPromotionCode = () => {
    return useUpdateModel<Entities.OrderPromotionCode>("orderPromotionCodes");
};
export const useDeleteOrderPromotionCode = () => {
    return useDeleteModel<Entities.OrderPromotionCode>("orderPromotionCodes");
};
export const useGetOrderStatusMappings = (parameter?: ODataParameter) => {
    return useGetModels<Entities.OrderStatusMapping>(parameter, "orderStatusMappings");
};
export const useGetOrderStatusMapping = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.OrderStatusMapping>(id, parameter, "orderStatusMappings");
};
export const useUpdateOrderStatusMapping = () => {
    return useUpdateModel<Entities.OrderStatusMapping>("orderStatusMappings");
};
export const useDeleteOrderStatusMapping = () => {
    return useDeleteModel<Entities.OrderStatusMapping>("orderStatusMappings");
};
export const useGetPages = (parameter?: ODataParameter) => {
    return useGetModels<Entities.Page>(parameter, "pages");
};
export const useGetPage = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.Page>(id, parameter, "pages");
};
export const useUpdatePage = () => {
    return useUpdateModel<Entities.Page>("pages");
};
export const useDeletePage = () => {
    return useDeleteModel<Entities.Page>("pages");
};
export const useGetPageStates = (parameter?: ODataParameter) => {
    return useGetModels<Entities.PageState>(parameter, "pageStates");
};
export const useGetPageState = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.PageState>(id, parameter, "pageStates");
};
export const useUpdatePageState = () => {
    return useUpdateModel<Entities.PageState>("pageStates");
};
export const useDeletePageState = () => {
    return useDeleteModel<Entities.PageState>("pageStates");
};
export const useGetPageStateContexts = (parameter?: ODataParameter) => {
    return useGetModels<Entities.PageStateContext>(parameter, "pageStateContexts");
};
export const useGetPageStateContext = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.PageStateContext>(id, parameter, "pageStateContexts");
};
export const useUpdatePageStateContext = () => {
    return useUpdateModel<Entities.PageStateContext>("pageStateContexts");
};
export const useDeletePageStateContext = () => {
    return useDeleteModel<Entities.PageStateContext>("pageStateContexts");
};
export const useGetTemporaryPages = (parameter?: ODataParameter) => {
    return useGetModels<Entities.TemporaryPage>(parameter, "temporaryPages");
};
export const useGetTemporaryPage = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.TemporaryPage>(id, parameter, "temporaryPages");
};
export const useUpdateTemporaryPage = () => {
    return useUpdateModel<Entities.TemporaryPage>("temporaryPages");
};
export const useDeleteTemporaryPage = () => {
    return useDeleteModel<Entities.TemporaryPage>("temporaryPages");
};
export const useGetPageUrls = (parameter?: ODataParameter) => {
    return useGetModels<Entities.PageUrl>(parameter, "pageUrls");
};
export const useGetPageUrl = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.PageUrl>(id, parameter, "pageUrls");
};
export const useUpdatePageUrl = () => {
    return useUpdateModel<Entities.PageUrl>("pageUrls");
};
export const useDeletePageUrl = () => {
    return useDeleteModel<Entities.PageUrl>("pageUrls");
};
export const useGetPageVersions = (parameter?: ODataParameter) => {
    return useGetModels<Entities.PageVersion>(parameter, "pageVersions");
};
export const useGetPageVersion = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.PageVersion>(id, parameter, "pageVersions");
};
export const useUpdatePageVersion = () => {
    return useUpdateModel<Entities.PageVersion>("pageVersions");
};
export const useDeletePageVersion = () => {
    return useDeleteModel<Entities.PageVersion>("pageVersions");
};
export const useGetPaymentMethods = (parameter?: ODataParameter) => {
    return useGetModels<Entities.PaymentMethod>(parameter, "paymentMethods");
};
export const useGetPaymentMethod = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.PaymentMethod>(id, parameter, "paymentMethods");
};
export const useUpdatePaymentMethod = () => {
    return useUpdateModel<Entities.PaymentMethod>("paymentMethods");
};
export const useDeletePaymentMethod = () => {
    return useDeleteModel<Entities.PaymentMethod>("paymentMethods");
};
export const useGetPersonas = (parameter?: ODataParameter) => {
    return useGetModels<Entities.Persona>(parameter, "personas");
};
export const useGetPersona = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.Persona>(id, parameter, "personas");
};
export const useUpdatePersona = () => {
    return useUpdateModel<Entities.Persona>("personas");
};
export const useDeletePersona = () => {
    return useDeleteModel<Entities.Persona>("personas");
};
export const useGetPersonaUserProfiles = (parameter?: ODataParameter) => {
    return useGetModels<Entities.PersonaUserProfile>(parameter, "personaUserProfiles");
};
export const useGetPersonaUserProfile = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.PersonaUserProfile>(id, parameter, "personaUserProfiles");
};
export const useUpdatePersonaUserProfile = () => {
    return useUpdateModel<Entities.PersonaUserProfile>("personaUserProfiles");
};
export const useDeletePersonaUserProfile = () => {
    return useDeleteModel<Entities.PersonaUserProfile>("personaUserProfiles");
};
export const useGetPlugins = (parameter?: ODataParameter) => {
    return useGetModels<Entities.Plugin>(parameter, "plugins");
};
export const useGetPlugin = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.Plugin>(id, parameter, "plugins");
};
export const useUpdatePlugin = () => {
    return useUpdateModel<Entities.Plugin>("plugins");
};
export const useDeletePlugin = () => {
    return useDeleteModel<Entities.Plugin>("plugins");
};
export const useGetPriceMatrices = (parameter?: ODataParameter) => {
    return useGetModels<Entities.PriceMatrix>(parameter, "priceMatrices");
};
export const useGetPriceMatrix = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.PriceMatrix>(id, parameter, "priceMatrices");
};
export const useUpdatePriceMatrix = () => {
    return useUpdateModel<Entities.PriceMatrix>("priceMatrices");
};
export const useDeletePriceMatrix = () => {
    return useDeleteModel<Entities.PriceMatrix>("priceMatrices");
};
export const useGetProducts = (parameter?: ODataParameter) => {
    return useGetModels<Entities.Product>(parameter, "products");
};
export const useGetProduct = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.Product>(id, parameter, "products");
};
export const useUpdateProduct = () => {
    return useUpdateModel<Entities.Product>("products");
};
export const useDeleteProduct = () => {
    return useDeleteModel<Entities.Product>("products");
};
export const useGetProductAlsoPurchasedWiths = (parameter?: ODataParameter) => {
    return useGetModels<Entities.ProductAlsoPurchasedWith>(parameter, "productAlsoPurchasedWiths");
};
export const useGetProductAlsoPurchasedWith = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.ProductAlsoPurchasedWith>(id, parameter, "productAlsoPurchasedWiths");
};
export const useUpdateProductAlsoPurchasedWith = () => {
    return useUpdateModel<Entities.ProductAlsoPurchasedWith>("productAlsoPurchasedWiths");
};
export const useDeleteProductAlsoPurchasedWith = () => {
    return useDeleteModel<Entities.ProductAlsoPurchasedWith>("productAlsoPurchasedWiths");
};
export const useGetProductAttributeValues = (parameter?: ODataParameter) => {
    return useGetModels<Entities.ProductAttributeValue>(parameter, "productAttributeValues");
};
export const useGetProductAttributeValue = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.ProductAttributeValue>(id, parameter, "productAttributeValues");
};
export const useUpdateProductAttributeValue = () => {
    return useUpdateModel<Entities.ProductAttributeValue>("productAttributeValues");
};
export const useDeleteProductAttributeValue = () => {
    return useDeleteModel<Entities.ProductAttributeValue>("productAttributeValues");
};
export const useGetProductImages = (parameter?: ODataParameter) => {
    return useGetModels<Entities.ProductImage>(parameter, "productImages");
};
export const useGetProductImage = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.ProductImage>(id, parameter, "productImages");
};
export const useUpdateProductImage = () => {
    return useUpdateModel<Entities.ProductImage>("productImages");
};
export const useDeleteProductImage = () => {
    return useDeleteModel<Entities.ProductImage>("productImages");
};
export const useGetProductKitSections = (parameter?: ODataParameter) => {
    return useGetModels<Entities.ProductKitSection>(parameter, "productKitSections");
};
export const useGetProductKitSection = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.ProductKitSection>(id, parameter, "productKitSections");
};
export const useUpdateProductKitSection = () => {
    return useUpdateModel<Entities.ProductKitSection>("productKitSections");
};
export const useDeleteProductKitSection = () => {
    return useDeleteModel<Entities.ProductKitSection>("productKitSections");
};
export const useGetProductKitSectionOptions = (parameter?: ODataParameter) => {
    return useGetModels<Entities.ProductKitSectionOption>(parameter, "productKitSectionOptions");
};
export const useGetProductKitSectionOption = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.ProductKitSectionOption>(id, parameter, "productKitSectionOptions");
};
export const useUpdateProductKitSectionOption = () => {
    return useUpdateModel<Entities.ProductKitSectionOption>("productKitSectionOptions");
};
export const useDeleteProductKitSectionOption = () => {
    return useDeleteModel<Entities.ProductKitSectionOption>("productKitSectionOptions");
};
export const useGetProductLines = (parameter?: ODataParameter) => {
    return useGetModels<Entities.ProductLine>(parameter, "productLines");
};
export const useGetProductLine = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.ProductLine>(id, parameter, "productLines");
};
export const useUpdateProductLine = () => {
    return useUpdateModel<Entities.ProductLine>("productLines");
};
export const useDeleteProductLine = () => {
    return useDeleteModel<Entities.ProductLine>("productLines");
};
export const useGetProductRelatedProducts = (parameter?: ODataParameter) => {
    return useGetModels<Entities.ProductRelatedProduct>(parameter, "productRelatedProducts");
};
export const useGetProductRelatedProduct = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.ProductRelatedProduct>(id, parameter, "productRelatedProducts");
};
export const useUpdateProductRelatedProduct = () => {
    return useUpdateModel<Entities.ProductRelatedProduct>("productRelatedProducts");
};
export const useDeleteProductRelatedProduct = () => {
    return useDeleteModel<Entities.ProductRelatedProduct>("productRelatedProducts");
};
export const useGetProductTaxExemptions = (parameter?: ODataParameter) => {
    return useGetModels<Entities.ProductTaxExemption>(parameter, "productTaxExemptions");
};
export const useGetProductTaxExemption = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.ProductTaxExemption>(id, parameter, "productTaxExemptions");
};
export const useUpdateProductTaxExemption = () => {
    return useUpdateModel<Entities.ProductTaxExemption>("productTaxExemptions");
};
export const useDeleteProductTaxExemption = () => {
    return useDeleteModel<Entities.ProductTaxExemption>("productTaxExemptions");
};
export const useGetProductTopSellers = (parameter?: ODataParameter) => {
    return useGetModels<Entities.ProductTopSeller>(parameter, "productTopSellers");
};
export const useGetProductTopSeller = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.ProductTopSeller>(id, parameter, "productTopSellers");
};
export const useUpdateProductTopSeller = () => {
    return useUpdateModel<Entities.ProductTopSeller>("productTopSellers");
};
export const useDeleteProductTopSeller = () => {
    return useDeleteModel<Entities.ProductTopSeller>("productTopSellers");
};
export const useGetProductUnitOfMeasures = (parameter?: ODataParameter) => {
    return useGetModels<Entities.ProductUnitOfMeasure>(parameter, "productUnitOfMeasures");
};
export const useGetProductUnitOfMeasure = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.ProductUnitOfMeasure>(id, parameter, "productUnitOfMeasures");
};
export const useUpdateProductUnitOfMeasure = () => {
    return useUpdateModel<Entities.ProductUnitOfMeasure>("productUnitOfMeasures");
};
export const useDeleteProductUnitOfMeasure = () => {
    return useDeleteModel<Entities.ProductUnitOfMeasure>("productUnitOfMeasures");
};
export const useGetProductWarehouses = (parameter?: ODataParameter) => {
    return useGetModels<Entities.ProductWarehouse>(parameter, "productWarehouses");
};
export const useGetProductWarehouse = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.ProductWarehouse>(id, parameter, "productWarehouses");
};
export const useUpdateProductWarehouse = () => {
    return useUpdateModel<Entities.ProductWarehouse>("productWarehouses");
};
export const useDeleteProductWarehouse = () => {
    return useDeleteModel<Entities.ProductWarehouse>("productWarehouses");
};
export const useGetPromotions = (parameter?: ODataParameter) => {
    return useGetModels<Entities.Promotion>(parameter, "promotions");
};
export const useGetPromotion = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.Promotion>(id, parameter, "promotions");
};
export const useUpdatePromotion = () => {
    return useUpdateModel<Entities.Promotion>("promotions");
};
export const useDeletePromotion = () => {
    return useDeleteModel<Entities.Promotion>("promotions");
};
export const useGetPromotionResults = (parameter?: ODataParameter) => {
    return useGetModels<Entities.PromotionResult>(parameter, "promotionResults");
};
export const useGetPromotionResult = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.PromotionResult>(id, parameter, "promotionResults");
};
export const useUpdatePromotionResult = () => {
    return useUpdateModel<Entities.PromotionResult>("promotionResults");
};
export const useDeletePromotionResult = () => {
    return useDeleteModel<Entities.PromotionResult>("promotionResults");
};
export const useGetPropertyAttributeConfigurations = (parameter?: ODataParameter) => {
    return useGetModels<Entities.PropertyAttributeConfiguration>(parameter, "propertyAttributeConfigurations");
};
export const useGetPropertyAttributeConfiguration = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.PropertyAttributeConfiguration>(id, parameter, "propertyAttributeConfigurations");
};
export const useUpdatePropertyAttributeConfiguration = () => {
    return useUpdateModel<Entities.PropertyAttributeConfiguration>("propertyAttributeConfigurations");
};
export const useDeletePropertyAttributeConfiguration = () => {
    return useDeleteModel<Entities.PropertyAttributeConfiguration>("propertyAttributeConfigurations");
};
export const useGetPropertyConfigurations = (parameter?: ODataParameter) => {
    return useGetModels<Entities.PropertyConfiguration>(parameter, "propertyConfigurations");
};
export const useGetPropertyConfiguration = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.PropertyConfiguration>(id, parameter, "propertyConfigurations");
};
export const useUpdatePropertyConfiguration = () => {
    return useUpdateModel<Entities.PropertyConfiguration>("propertyConfigurations");
};
export const useDeletePropertyConfiguration = () => {
    return useDeleteModel<Entities.PropertyConfiguration>("propertyConfigurations");
};
export const useGetPropertyPermissions = (parameter?: ODataParameter) => {
    return useGetModels<Entities.PropertyPermission>(parameter, "propertyPermissions");
};
export const useGetPropertyPermission = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.PropertyPermission>(id, parameter, "propertyPermissions");
};
export const useUpdatePropertyPermission = () => {
    return useUpdateModel<Entities.PropertyPermission>("propertyPermissions");
};
export const useDeletePropertyPermission = () => {
    return useDeleteModel<Entities.PropertyPermission>("propertyPermissions");
};
export const useGetPunchOutCustomerUserProfileMaps = (parameter?: ODataParameter) => {
    return useGetModels<Entities.PunchOutCustomerUserProfileMap>(parameter, "punchOutCustomerUserProfileMaps");
};
export const useGetPunchOutCustomerUserProfileMap = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.PunchOutCustomerUserProfileMap>(id, parameter, "punchOutCustomerUserProfileMaps");
};
export const useUpdatePunchOutCustomerUserProfileMap = () => {
    return useUpdateModel<Entities.PunchOutCustomerUserProfileMap>("punchOutCustomerUserProfileMaps");
};
export const useDeletePunchOutCustomerUserProfileMap = () => {
    return useDeleteModel<Entities.PunchOutCustomerUserProfileMap>("punchOutCustomerUserProfileMaps");
};
export const useGetPunchOutOrderRequests = (parameter?: ODataParameter) => {
    return useGetModels<Entities.PunchOutOrderRequest>(parameter, "punchOutOrderRequests");
};
export const useGetPunchOutOrderRequest = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.PunchOutOrderRequest>(id, parameter, "punchOutOrderRequests");
};
export const useUpdatePunchOutOrderRequest = () => {
    return useUpdateModel<Entities.PunchOutOrderRequest>("punchOutOrderRequests");
};
export const useDeletePunchOutOrderRequest = () => {
    return useDeleteModel<Entities.PunchOutOrderRequest>("punchOutOrderRequests");
};
export const useGetPunchOutOrderRequestExtrinsics = (parameter?: ODataParameter) => {
    return useGetModels<Entities.PunchOutOrderRequestExtrinsic>(parameter, "punchOutOrderRequestExtrinsics");
};
export const useGetPunchOutOrderRequestExtrinsic = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.PunchOutOrderRequestExtrinsic>(id, parameter, "punchOutOrderRequestExtrinsics");
};
export const useUpdatePunchOutOrderRequestExtrinsic = () => {
    return useUpdateModel<Entities.PunchOutOrderRequestExtrinsic>("punchOutOrderRequestExtrinsics");
};
export const useDeletePunchOutOrderRequestExtrinsic = () => {
    return useDeleteModel<Entities.PunchOutOrderRequestExtrinsic>("punchOutOrderRequestExtrinsics");
};
export const useGetPunchOutOrderRequestItemOuts = (parameter?: ODataParameter) => {
    return useGetModels<Entities.PunchOutOrderRequestItemOut>(parameter, "punchOutOrderRequestItemOuts");
};
export const useGetPunchOutOrderRequestItemOut = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.PunchOutOrderRequestItemOut>(id, parameter, "punchOutOrderRequestItemOuts");
};
export const useUpdatePunchOutOrderRequestItemOut = () => {
    return useUpdateModel<Entities.PunchOutOrderRequestItemOut>("punchOutOrderRequestItemOuts");
};
export const useDeletePunchOutOrderRequestItemOut = () => {
    return useDeleteModel<Entities.PunchOutOrderRequestItemOut>("punchOutOrderRequestItemOuts");
};
export const useGetPunchOutOrderRequestItemOutExtrinsics = (parameter?: ODataParameter) => {
    return useGetModels<Entities.PunchOutOrderRequestItemOutExtrinsic>(parameter, "punchOutOrderRequestItemOutExtrinsics");
};
export const useGetPunchOutOrderRequestItemOutExtrinsic = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.PunchOutOrderRequestItemOutExtrinsic>(id, parameter, "punchOutOrderRequestItemOutExtrinsics");
};
export const useUpdatePunchOutOrderRequestItemOutExtrinsic = () => {
    return useUpdateModel<Entities.PunchOutOrderRequestItemOutExtrinsic>("punchOutOrderRequestItemOutExtrinsics");
};
export const useDeletePunchOutOrderRequestItemOutExtrinsic = () => {
    return useDeleteModel<Entities.PunchOutOrderRequestItemOutExtrinsic>("punchOutOrderRequestItemOutExtrinsics");
};
export const useGetPunchOutOrderRequestMessages = (parameter?: ODataParameter) => {
    return useGetModels<Entities.PunchOutOrderRequestMessage>(parameter, "punchOutOrderRequestMessages");
};
export const useGetPunchOutOrderRequestMessage = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.PunchOutOrderRequestMessage>(id, parameter, "punchOutOrderRequestMessages");
};
export const useUpdatePunchOutOrderRequestMessage = () => {
    return useUpdateModel<Entities.PunchOutOrderRequestMessage>("punchOutOrderRequestMessages");
};
export const useDeletePunchOutOrderRequestMessage = () => {
    return useDeleteModel<Entities.PunchOutOrderRequestMessage>("punchOutOrderRequestMessages");
};
export const useGetPunchOutSessions = (parameter?: ODataParameter) => {
    return useGetModels<Entities.PunchOutSession>(parameter, "punchOutSessions");
};
export const useGetPunchOutSession = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.PunchOutSession>(id, parameter, "punchOutSessions");
};
export const useUpdatePunchOutSession = () => {
    return useUpdateModel<Entities.PunchOutSession>("punchOutSessions");
};
export const useDeletePunchOutSession = () => {
    return useDeleteModel<Entities.PunchOutSession>("punchOutSessions");
};
export const useGetPunchOutSessionAccesses = (parameter?: ODataParameter) => {
    return useGetModels<Entities.PunchOutSessionAccess>(parameter, "punchOutSessionAccesses");
};
export const useGetPunchOutSessionAccess = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.PunchOutSessionAccess>(id, parameter, "punchOutSessionAccesses");
};
export const useUpdatePunchOutSessionAccess = () => {
    return useUpdateModel<Entities.PunchOutSessionAccess>("punchOutSessionAccesses");
};
export const useDeletePunchOutSessionAccess = () => {
    return useDeleteModel<Entities.PunchOutSessionAccess>("punchOutSessionAccesses");
};
export const useGetPunchOutSessionExtrinsics = (parameter?: ODataParameter) => {
    return useGetModels<Entities.PunchOutSessionExtrinsic>(parameter, "punchOutSessionExtrinsics");
};
export const useGetPunchOutSessionExtrinsic = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.PunchOutSessionExtrinsic>(id, parameter, "punchOutSessionExtrinsics");
};
export const useUpdatePunchOutSessionExtrinsic = () => {
    return useUpdateModel<Entities.PunchOutSessionExtrinsic>("punchOutSessionExtrinsics");
};
export const useDeletePunchOutSessionExtrinsic = () => {
    return useDeleteModel<Entities.PunchOutSessionExtrinsic>("punchOutSessionExtrinsics");
};
export const useGetPunchOutSessionItemIns = (parameter?: ODataParameter) => {
    return useGetModels<Entities.PunchOutSessionItemIn>(parameter, "punchOutSessionItemIns");
};
export const useGetPunchOutSessionItemIn = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.PunchOutSessionItemIn>(id, parameter, "punchOutSessionItemIns");
};
export const useUpdatePunchOutSessionItemIn = () => {
    return useUpdateModel<Entities.PunchOutSessionItemIn>("punchOutSessionItemIns");
};
export const useDeletePunchOutSessionItemIn = () => {
    return useDeleteModel<Entities.PunchOutSessionItemIn>("punchOutSessionItemIns");
};
export const useGetPunchOutSetupRequests = (parameter?: ODataParameter) => {
    return useGetModels<Entities.PunchOutSetupRequest>(parameter, "punchOutSetupRequests");
};
export const useGetPunchOutSetupRequest = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.PunchOutSetupRequest>(id, parameter, "punchOutSetupRequests");
};
export const useUpdatePunchOutSetupRequest = () => {
    return useUpdateModel<Entities.PunchOutSetupRequest>("punchOutSetupRequests");
};
export const useDeletePunchOutSetupRequest = () => {
    return useDeleteModel<Entities.PunchOutSetupRequest>("punchOutSetupRequests");
};
export const useGetRestrictionGroups = (parameter?: ODataParameter) => {
    return useGetModels<Entities.RestrictionGroup>(parameter, "restrictionGroups");
};
export const useGetRestrictionGroup = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.RestrictionGroup>(id, parameter, "restrictionGroups");
};
export const useUpdateRestrictionGroup = () => {
    return useUpdateModel<Entities.RestrictionGroup>("restrictionGroups");
};
export const useDeleteRestrictionGroup = () => {
    return useDeleteModel<Entities.RestrictionGroup>("restrictionGroups");
};
export const useGetRestrictionGroupCustomers = (parameter?: ODataParameter) => {
    return useGetModels<Entities.RestrictionGroupCustomer>(parameter, "restrictionGroupCustomers");
};
export const useGetRestrictionGroupCustomer = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.RestrictionGroupCustomer>(id, parameter, "restrictionGroupCustomers");
};
export const useUpdateRestrictionGroupCustomer = () => {
    return useUpdateModel<Entities.RestrictionGroupCustomer>("restrictionGroupCustomers");
};
export const useDeleteRestrictionGroupCustomer = () => {
    return useDeleteModel<Entities.RestrictionGroupCustomer>("restrictionGroupCustomers");
};
export const useGetRestrictionGroupCustomerAdditions = (parameter?: ODataParameter) => {
    return useGetModels<Entities.RestrictionGroupCustomerAddition>(parameter, "restrictionGroupCustomerAdditions");
};
export const useGetRestrictionGroupCustomerAddition = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.RestrictionGroupCustomerAddition>(id, parameter, "restrictionGroupCustomerAdditions");
};
export const useUpdateRestrictionGroupCustomerAddition = () => {
    return useUpdateModel<Entities.RestrictionGroupCustomerAddition>("restrictionGroupCustomerAdditions");
};
export const useDeleteRestrictionGroupCustomerAddition = () => {
    return useDeleteModel<Entities.RestrictionGroupCustomerAddition>("restrictionGroupCustomerAdditions");
};
export const useGetRestrictionGroupCustomerExceptions = (parameter?: ODataParameter) => {
    return useGetModels<Entities.RestrictionGroupCustomerException>(parameter, "restrictionGroupCustomerExceptions");
};
export const useGetRestrictionGroupCustomerException = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.RestrictionGroupCustomerException>(id, parameter, "restrictionGroupCustomerExceptions");
};
export const useUpdateRestrictionGroupCustomerException = () => {
    return useUpdateModel<Entities.RestrictionGroupCustomerException>("restrictionGroupCustomerExceptions");
};
export const useDeleteRestrictionGroupCustomerException = () => {
    return useDeleteModel<Entities.RestrictionGroupCustomerException>("restrictionGroupCustomerExceptions");
};
export const useGetRestrictionGroupProducts = (parameter?: ODataParameter) => {
    return useGetModels<Entities.RestrictionGroupProduct>(parameter, "restrictionGroupProducts");
};
export const useGetRestrictionGroupProduct = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.RestrictionGroupProduct>(id, parameter, "restrictionGroupProducts");
};
export const useUpdateRestrictionGroupProduct = () => {
    return useUpdateModel<Entities.RestrictionGroupProduct>("restrictionGroupProducts");
};
export const useDeleteRestrictionGroupProduct = () => {
    return useDeleteModel<Entities.RestrictionGroupProduct>("restrictionGroupProducts");
};
export const useGetRestrictionGroupProductAdditions = (parameter?: ODataParameter) => {
    return useGetModels<Entities.RestrictionGroupProductAddition>(parameter, "restrictionGroupProductAdditions");
};
export const useGetRestrictionGroupProductAddition = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.RestrictionGroupProductAddition>(id, parameter, "restrictionGroupProductAdditions");
};
export const useUpdateRestrictionGroupProductAddition = () => {
    return useUpdateModel<Entities.RestrictionGroupProductAddition>("restrictionGroupProductAdditions");
};
export const useDeleteRestrictionGroupProductAddition = () => {
    return useDeleteModel<Entities.RestrictionGroupProductAddition>("restrictionGroupProductAdditions");
};
export const useGetRestrictionGroupProductExceptions = (parameter?: ODataParameter) => {
    return useGetModels<Entities.RestrictionGroupProductException>(parameter, "restrictionGroupProductExceptions");
};
export const useGetRestrictionGroupProductException = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.RestrictionGroupProductException>(id, parameter, "restrictionGroupProductExceptions");
};
export const useUpdateRestrictionGroupProductException = () => {
    return useUpdateModel<Entities.RestrictionGroupProductException>("restrictionGroupProductExceptions");
};
export const useDeleteRestrictionGroupProductException = () => {
    return useDeleteModel<Entities.RestrictionGroupProductException>("restrictionGroupProductExceptions");
};
export const useGetRestrictionGroupWebsites = (parameter?: ODataParameter) => {
    return useGetModels<Entities.RestrictionGroupWebsite>(parameter, "restrictionGroupWebsites");
};
export const useGetRestrictionGroupWebsite = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.RestrictionGroupWebsite>(id, parameter, "restrictionGroupWebsites");
};
export const useUpdateRestrictionGroupWebsite = () => {
    return useUpdateModel<Entities.RestrictionGroupWebsite>("restrictionGroupWebsites");
};
export const useDeleteRestrictionGroupWebsite = () => {
    return useDeleteModel<Entities.RestrictionGroupWebsite>("restrictionGroupWebsites");
};
export const useGetRoles = (parameter?: ODataParameter) => {
    return useGetModels<Entities.Role>(parameter, "roles");
};
export const useGetRole = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.Role>(id, parameter, "roles");
};
export const useUpdateRole = () => {
    return useUpdateModel<Entities.Role>("roles");
};
export const useDeleteRole = () => {
    return useDeleteModel<Entities.Role>("roles");
};
export const useGetRuleClauses = (parameter?: ODataParameter) => {
    return useGetModels<Entities.RuleClause>(parameter, "ruleClauses");
};
export const useGetRuleClause = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.RuleClause>(id, parameter, "ruleClauses");
};
export const useUpdateRuleClause = () => {
    return useUpdateModel<Entities.RuleClause>("ruleClauses");
};
export const useDeleteRuleClause = () => {
    return useDeleteModel<Entities.RuleClause>("ruleClauses");
};
export const useGetRuleManagers = (parameter?: ODataParameter) => {
    return useGetModels<Entities.RuleManager>(parameter, "ruleManagers");
};
export const useGetRuleManager = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.RuleManager>(id, parameter, "ruleManagers");
};
export const useUpdateRuleManager = () => {
    return useUpdateModel<Entities.RuleManager>("ruleManagers");
};
export const useDeleteRuleManager = () => {
    return useDeleteModel<Entities.RuleManager>("ruleManagers");
};
export const useGetRuleTypes = (parameter?: ODataParameter) => {
    return useGetModels<Entities.RuleType>(parameter, "ruleTypes");
};
export const useGetRuleType = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.RuleType>(id, parameter, "ruleTypes");
};
export const useUpdateRuleType = () => {
    return useUpdateModel<Entities.RuleType>("ruleTypes");
};
export const useDeleteRuleType = () => {
    return useDeleteModel<Entities.RuleType>("ruleTypes");
};
export const useGetRuleTypeOptions = (parameter?: ODataParameter) => {
    return useGetModels<Entities.RuleTypeOption>(parameter, "ruleTypeOptions");
};
export const useGetRuleTypeOption = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.RuleTypeOption>(id, parameter, "ruleTypeOptions");
};
export const useUpdateRuleTypeOption = () => {
    return useUpdateModel<Entities.RuleTypeOption>("ruleTypeOptions");
};
export const useDeleteRuleTypeOption = () => {
    return useDeleteModel<Entities.RuleTypeOption>("ruleTypeOptions");
};
export const useGetSalespersons = (parameter?: ODataParameter) => {
    return useGetModels<Entities.Salesperson>(parameter, "salespersons");
};
export const useGetSalesperson = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.Salesperson>(id, parameter, "salespersons");
};
export const useUpdateSalesperson = () => {
    return useUpdateModel<Entities.Salesperson>("salespersons");
};
export const useDeleteSalesperson = () => {
    return useDeleteModel<Entities.Salesperson>("salespersons");
};
export const useGetSearchBoosts = (parameter?: ODataParameter) => {
    return useGetModels<Entities.SearchBoost>(parameter, "searchBoosts");
};
export const useGetSearchBoost = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.SearchBoost>(id, parameter, "searchBoosts");
};
export const useUpdateSearchBoost = () => {
    return useUpdateModel<Entities.SearchBoost>("searchBoosts");
};
export const useDeleteSearchBoost = () => {
    return useDeleteModel<Entities.SearchBoost>("searchBoosts");
};
export const useGetSearchStopwords = (parameter?: ODataParameter) => {
    return useGetModels<Entities.SearchStopword>(parameter, "searchStopwords");
};
export const useGetSearchStopword = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.SearchStopword>(id, parameter, "searchStopwords");
};
export const useUpdateSearchStopword = () => {
    return useUpdateModel<Entities.SearchStopword>("searchStopwords");
};
export const useDeleteSearchStopword = () => {
    return useDeleteModel<Entities.SearchStopword>("searchStopwords");
};
export const useGetSearchSynonyms = (parameter?: ODataParameter) => {
    return useGetModels<Entities.SearchSynonym>(parameter, "searchSynonyms");
};
export const useGetSearchSynonym = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.SearchSynonym>(id, parameter, "searchSynonyms");
};
export const useUpdateSearchSynonym = () => {
    return useUpdateModel<Entities.SearchSynonym>("searchSynonyms");
};
export const useDeleteSearchSynonym = () => {
    return useDeleteModel<Entities.SearchSynonym>("searchSynonyms");
};
export const useGetSearchTermRedirects = (parameter?: ODataParameter) => {
    return useGetModels<Entities.SearchTermRedirect>(parameter, "searchTermRedirects");
};
export const useGetSearchTermRedirect = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.SearchTermRedirect>(id, parameter, "searchTermRedirects");
};
export const useUpdateSearchTermRedirect = () => {
    return useUpdateModel<Entities.SearchTermRedirect>("searchTermRedirects");
};
export const useDeleteSearchTermRedirect = () => {
    return useDeleteModel<Entities.SearchTermRedirect>("searchTermRedirects");
};
export const useGetShipCharges = (parameter?: ODataParameter) => {
    return useGetModels<Entities.ShipCharge>(parameter, "shipCharges");
};
export const useGetShipCharge = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.ShipCharge>(id, parameter, "shipCharges");
};
export const useUpdateShipCharge = () => {
    return useUpdateModel<Entities.ShipCharge>("shipCharges");
};
export const useDeleteShipCharge = () => {
    return useDeleteModel<Entities.ShipCharge>("shipCharges");
};
export const useGetShipRates = (parameter?: ODataParameter) => {
    return useGetModels<Entities.ShipRate>(parameter, "shipRates");
};
export const useGetShipRate = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.ShipRate>(id, parameter, "shipRates");
};
export const useUpdateShipRate = () => {
    return useUpdateModel<Entities.ShipRate>("shipRates");
};
export const useDeleteShipRate = () => {
    return useDeleteModel<Entities.ShipRate>("shipRates");
};
export const useGetShipRules = (parameter?: ODataParameter) => {
    return useGetModels<Entities.ShipRule>(parameter, "shipRules");
};
export const useGetShipRule = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.ShipRule>(id, parameter, "shipRules");
};
export const useUpdateShipRule = () => {
    return useUpdateModel<Entities.ShipRule>("shipRules");
};
export const useDeleteShipRule = () => {
    return useDeleteModel<Entities.ShipRule>("shipRules");
};
export const useGetShipToAddressFields = (parameter?: ODataParameter) => {
    return useGetModels<Entities.ShipToAddressField>(parameter, "shipToAddressFields");
};
export const useGetShipToAddressField = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.ShipToAddressField>(id, parameter, "shipToAddressFields");
};
export const useUpdateShipToAddressField = () => {
    return useUpdateModel<Entities.ShipToAddressField>("shipToAddressFields");
};
export const useDeleteShipToAddressField = () => {
    return useDeleteModel<Entities.ShipToAddressField>("shipToAddressFields");
};
export const useGetShipVias = (parameter?: ODataParameter) => {
    return useGetModels<Entities.ShipVia>(parameter, "shipVias");
};
export const useGetShipVia = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.ShipVia>(id, parameter, "shipVias");
};
export const useUpdateShipVia = () => {
    return useUpdateModel<Entities.ShipVia>("shipVias");
};
export const useDeleteShipVia = () => {
    return useDeleteModel<Entities.ShipVia>("shipVias");
};
export const useGetShipments = (parameter?: ODataParameter) => {
    return useGetModels<Entities.Shipment>(parameter, "shipments");
};
export const useGetShipment = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.Shipment>(id, parameter, "shipments");
};
export const useUpdateShipment = () => {
    return useUpdateModel<Entities.Shipment>("shipments");
};
export const useDeleteShipment = () => {
    return useDeleteModel<Entities.Shipment>("shipments");
};
export const useGetShipmentPackages = (parameter?: ODataParameter) => {
    return useGetModels<Entities.ShipmentPackage>(parameter, "shipmentPackages");
};
export const useGetShipmentPackage = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.ShipmentPackage>(id, parameter, "shipmentPackages");
};
export const useUpdateShipmentPackage = () => {
    return useUpdateModel<Entities.ShipmentPackage>("shipmentPackages");
};
export const useDeleteShipmentPackage = () => {
    return useDeleteModel<Entities.ShipmentPackage>("shipmentPackages");
};
export const useGetShipmentPackageLines = (parameter?: ODataParameter) => {
    return useGetModels<Entities.ShipmentPackageLine>(parameter, "shipmentPackageLines");
};
export const useGetShipmentPackageLine = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.ShipmentPackageLine>(id, parameter, "shipmentPackageLines");
};
export const useUpdateShipmentPackageLine = () => {
    return useUpdateModel<Entities.ShipmentPackageLine>("shipmentPackageLines");
};
export const useDeleteShipmentPackageLine = () => {
    return useDeleteModel<Entities.ShipmentPackageLine>("shipmentPackageLines");
};
export const useGetSpecifications = (parameter?: ODataParameter) => {
    return useGetModels<Entities.Specification>(parameter, "specifications");
};
export const useGetSpecification = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.Specification>(id, parameter, "specifications");
};
export const useUpdateSpecification = () => {
    return useUpdateModel<Entities.Specification>("specifications");
};
export const useDeleteSpecification = () => {
    return useDeleteModel<Entities.Specification>("specifications");
};
export const useGetSpireLogs = (parameter?: ODataParameter) => {
    return useGetModels<Entities.SpireLog>(parameter, "spireLogs");
};
export const useGetSpireLog = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.SpireLog>(id, parameter, "spireLogs");
};
export const useUpdateSpireLog = () => {
    return useUpdateModel<Entities.SpireLog>("spireLogs");
};
export const useDeleteSpireLog = () => {
    return useDeleteModel<Entities.SpireLog>("spireLogs");
};
export const useGetStates = (parameter?: ODataParameter) => {
    return useGetModels<Entities.State>(parameter, "states");
};
export const useGetState = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.State>(id, parameter, "states");
};
export const useUpdateState = () => {
    return useUpdateModel<Entities.State>("states");
};
export const useDeleteState = () => {
    return useDeleteModel<Entities.State>("states");
};
export const useGetStateTaxExemptions = (parameter?: ODataParameter) => {
    return useGetModels<Entities.StateTaxExemption>(parameter, "stateTaxExemptions");
};
export const useGetStateTaxExemption = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.StateTaxExemption>(id, parameter, "stateTaxExemptions");
};
export const useUpdateStateTaxExemption = () => {
    return useUpdateModel<Entities.StateTaxExemption>("stateTaxExemptions");
};
export const useDeleteStateTaxExemption = () => {
    return useDeleteModel<Entities.StateTaxExemption>("stateTaxExemptions");
};
export const useGetStyleClasses = (parameter?: ODataParameter) => {
    return useGetModels<Entities.StyleClass>(parameter, "styleClasses");
};
export const useGetStyleClass = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.StyleClass>(id, parameter, "styleClasses");
};
export const useUpdateStyleClass = () => {
    return useUpdateModel<Entities.StyleClass>("styleClasses");
};
export const useDeleteStyleClass = () => {
    return useDeleteModel<Entities.StyleClass>("styleClasses");
};
export const useGetStyleTraits = (parameter?: ODataParameter) => {
    return useGetModels<Entities.StyleTrait>(parameter, "styleTraits");
};
export const useGetStyleTrait = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.StyleTrait>(id, parameter, "styleTraits");
};
export const useUpdateStyleTrait = () => {
    return useUpdateModel<Entities.StyleTrait>("styleTraits");
};
export const useDeleteStyleTrait = () => {
    return useDeleteModel<Entities.StyleTrait>("styleTraits");
};
export const useGetStyleTraitValues = (parameter?: ODataParameter) => {
    return useGetModels<Entities.StyleTraitValue>(parameter, "styleTraitValues");
};
export const useGetStyleTraitValue = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.StyleTraitValue>(id, parameter, "styleTraitValues");
};
export const useUpdateStyleTraitValue = () => {
    return useUpdateModel<Entities.StyleTraitValue>("styleTraitValues");
};
export const useDeleteStyleTraitValue = () => {
    return useDeleteModel<Entities.StyleTraitValue>("styleTraitValues");
};
export const useGetStyleTraitValueProducts = (parameter?: ODataParameter) => {
    return useGetModels<Entities.StyleTraitValueProduct>(parameter, "styleTraitValueProducts");
};
export const useGetStyleTraitValueProduct = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.StyleTraitValueProduct>(id, parameter, "styleTraitValueProducts");
};
export const useUpdateStyleTraitValueProduct = () => {
    return useUpdateModel<Entities.StyleTraitValueProduct>("styleTraitValueProducts");
};
export const useDeleteStyleTraitValueProduct = () => {
    return useDeleteModel<Entities.StyleTraitValueProduct>("styleTraitValueProducts");
};
export const useGetSubscriptions = (parameter?: ODataParameter) => {
    return useGetModels<Entities.Subscription>(parameter, "subscriptions");
};
export const useGetSubscription = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.Subscription>(id, parameter, "subscriptions");
};
export const useUpdateSubscription = () => {
    return useUpdateModel<Entities.Subscription>("subscriptions");
};
export const useDeleteSubscription = () => {
    return useDeleteModel<Entities.Subscription>("subscriptions");
};
export const useGetSubscriptionLines = (parameter?: ODataParameter) => {
    return useGetModels<Entities.SubscriptionLine>(parameter, "subscriptionLines");
};
export const useGetSubscriptionLine = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.SubscriptionLine>(id, parameter, "subscriptionLines");
};
export const useUpdateSubscriptionLine = () => {
    return useUpdateModel<Entities.SubscriptionLine>("subscriptionLines");
};
export const useDeleteSubscriptionLine = () => {
    return useDeleteModel<Entities.SubscriptionLine>("subscriptionLines");
};
export const useGetSubscriptionProducts = (parameter?: ODataParameter) => {
    return useGetModels<Entities.SubscriptionProduct>(parameter, "subscriptionProducts");
};
export const useGetSubscriptionProduct = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.SubscriptionProduct>(id, parameter, "subscriptionProducts");
};
export const useUpdateSubscriptionProduct = () => {
    return useUpdateModel<Entities.SubscriptionProduct>("subscriptionProducts");
};
export const useDeleteSubscriptionProduct = () => {
    return useDeleteModel<Entities.SubscriptionProduct>("subscriptionProducts");
};
export const useGetSystemLists = (parameter?: ODataParameter) => {
    return useGetModels<Entities.SystemList>(parameter, "systemLists");
};
export const useGetSystemList = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.SystemList>(id, parameter, "systemLists");
};
export const useUpdateSystemList = () => {
    return useUpdateModel<Entities.SystemList>("systemLists");
};
export const useDeleteSystemList = () => {
    return useDeleteModel<Entities.SystemList>("systemLists");
};
export const useGetSystemListValues = (parameter?: ODataParameter) => {
    return useGetModels<Entities.SystemListValue>(parameter, "systemListValues");
};
export const useGetSystemListValue = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.SystemListValue>(id, parameter, "systemListValues");
};
export const useUpdateSystemListValue = () => {
    return useUpdateModel<Entities.SystemListValue>("systemListValues");
};
export const useDeleteSystemListValue = () => {
    return useDeleteModel<Entities.SystemListValue>("systemListValues");
};
export const useGetSystemSettings = (parameter?: ODataParameter) => {
    return useGetModels<Entities.SystemSetting>(parameter, "systemSettings");
};
export const useGetSystemSetting = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.SystemSetting>(id, parameter, "systemSettings");
};
export const useUpdateSystemSetting = () => {
    return useUpdateModel<Entities.SystemSetting>("systemSettings");
};
export const useDeleteSystemSetting = () => {
    return useDeleteModel<Entities.SystemSetting>("systemSettings");
};
export const useGetTaxExemptions = (parameter?: ODataParameter) => {
    return useGetModels<Entities.TaxExemption>(parameter, "taxExemptions");
};
export const useGetTaxExemption = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.TaxExemption>(id, parameter, "taxExemptions");
};
export const useUpdateTaxExemption = () => {
    return useUpdateModel<Entities.TaxExemption>("taxExemptions");
};
export const useDeleteTaxExemption = () => {
    return useDeleteModel<Entities.TaxExemption>("taxExemptions");
};
export const useGetThemes = (parameter?: ODataParameter) => {
    return useGetModels<Entities.Theme>(parameter, "themes");
};
export const useGetTheme = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.Theme>(id, parameter, "themes");
};
export const useUpdateTheme = () => {
    return useUpdateModel<Entities.Theme>("themes");
};
export const useDeleteTheme = () => {
    return useDeleteModel<Entities.Theme>("themes");
};
export const useGetTranslationDictionaries = (parameter?: ODataParameter) => {
    return useGetModels<Entities.TranslationDictionary>(parameter, "translationDictionaries");
};
export const useGetTranslationDictionary = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.TranslationDictionary>(id, parameter, "translationDictionaries");
};
export const useUpdateTranslationDictionary = () => {
    return useUpdateModel<Entities.TranslationDictionary>("translationDictionaries");
};
export const useDeleteTranslationDictionary = () => {
    return useDeleteModel<Entities.TranslationDictionary>("translationDictionaries");
};
export const useGetTranslationProperties = (parameter?: ODataParameter) => {
    return useGetModels<Entities.TranslationProperty>(parameter, "translationProperties");
};
export const useGetTranslationProperty = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.TranslationProperty>(id, parameter, "translationProperties");
};
export const useUpdateTranslationProperty = () => {
    return useUpdateModel<Entities.TranslationProperty>("translationProperties");
};
export const useDeleteTranslationProperty = () => {
    return useDeleteModel<Entities.TranslationProperty>("translationProperties");
};
export const useGetUserPaymentProfiles = (parameter?: ODataParameter) => {
    return useGetModels<Entities.UserPaymentProfile>(parameter, "userPaymentProfiles");
};
export const useGetUserPaymentProfile = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.UserPaymentProfile>(id, parameter, "userPaymentProfiles");
};
export const useUpdateUserPaymentProfile = () => {
    return useUpdateModel<Entities.UserPaymentProfile>("userPaymentProfiles");
};
export const useDeleteUserPaymentProfile = () => {
    return useDeleteModel<Entities.UserPaymentProfile>("userPaymentProfiles");
};
export const useGetUserProfiles = (parameter?: ODataParameter) => {
    return useGetModels<Entities.UserProfile>(parameter, "userProfiles");
};
export const useGetUserProfile = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.UserProfile>(id, parameter, "userProfiles");
};
export const useUpdateUserProfile = () => {
    return useUpdateModel<Entities.UserProfile>("userProfiles");
};
export const useDeleteUserProfile = () => {
    return useDeleteModel<Entities.UserProfile>("userProfiles");
};
export const useGetUserProfileEmailLists = (parameter?: ODataParameter) => {
    return useGetModels<Entities.UserProfileEmailList>(parameter, "userProfileEmailLists");
};
export const useGetUserProfileEmailList = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.UserProfileEmailList>(id, parameter, "userProfileEmailLists");
};
export const useUpdateUserProfileEmailList = () => {
    return useUpdateModel<Entities.UserProfileEmailList>("userProfileEmailLists");
};
export const useDeleteUserProfileEmailList = () => {
    return useDeleteModel<Entities.UserProfileEmailList>("userProfileEmailLists");
};
export const useGetUserProfileWebsites = (parameter?: ODataParameter) => {
    return useGetModels<Entities.UserProfileWebsite>(parameter, "userProfileWebsites");
};
export const useGetUserProfileWebsite = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.UserProfileWebsite>(id, parameter, "userProfileWebsites");
};
export const useUpdateUserProfileWebsite = () => {
    return useUpdateModel<Entities.UserProfileWebsite>("userProfileWebsites");
};
export const useDeleteUserProfileWebsite = () => {
    return useDeleteModel<Entities.UserProfileWebsite>("userProfileWebsites");
};
export const useGetUserProfileWishListFavorites = (parameter?: ODataParameter) => {
    return useGetModels<Entities.UserProfileWishListFavorite>(parameter, "userProfileWishListFavorites");
};
export const useGetUserProfileWishListFavorite = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.UserProfileWishListFavorite>(id, parameter, "userProfileWishListFavorites");
};
export const useUpdateUserProfileWishListFavorite = () => {
    return useUpdateModel<Entities.UserProfileWishListFavorite>("userProfileWishListFavorites");
};
export const useDeleteUserProfileWishListFavorite = () => {
    return useDeleteModel<Entities.UserProfileWishListFavorite>("userProfileWishListFavorites");
};
export const useGetUserProfileWishListHides = (parameter?: ODataParameter) => {
    return useGetModels<Entities.UserProfileWishListHide>(parameter, "userProfileWishListHides");
};
export const useGetUserProfileWishListHide = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.UserProfileWishListHide>(id, parameter, "userProfileWishListHides");
};
export const useUpdateUserProfileWishListHide = () => {
    return useUpdateModel<Entities.UserProfileWishListHide>("userProfileWishListHides");
};
export const useDeleteUserProfileWishListHide = () => {
    return useDeleteModel<Entities.UserProfileWishListHide>("userProfileWishListHides");
};
export const useGetUserProfileWishListTags = (parameter?: ODataParameter) => {
    return useGetModels<Entities.UserProfileWishListTag>(parameter, "userProfileWishListTags");
};
export const useGetUserProfileWishListTag = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.UserProfileWishListTag>(id, parameter, "userProfileWishListTags");
};
export const useUpdateUserProfileWishListTag = () => {
    return useUpdateModel<Entities.UserProfileWishListTag>("userProfileWishListTags");
};
export const useDeleteUserProfileWishListTag = () => {
    return useDeleteModel<Entities.UserProfileWishListTag>("userProfileWishListTags");
};
export const useGetVatCodes = (parameter?: ODataParameter) => {
    return useGetModels<Entities.VatCode>(parameter, "vatCodes");
};
export const useGetVatCode = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.VatCode>(id, parameter, "vatCodes");
};
export const useUpdateVatCode = () => {
    return useUpdateModel<Entities.VatCode>("vatCodes");
};
export const useDeleteVatCode = () => {
    return useDeleteModel<Entities.VatCode>("vatCodes");
};
export const useGetVendors = (parameter?: ODataParameter) => {
    return useGetModels<Entities.Vendor>(parameter, "vendors");
};
export const useGetVendor = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.Vendor>(id, parameter, "vendors");
};
export const useUpdateVendor = () => {
    return useUpdateModel<Entities.Vendor>("vendors");
};
export const useDeleteVendor = () => {
    return useDeleteModel<Entities.Vendor>("vendors");
};
export const useGetVersionHistories = (parameter?: ODataParameter) => {
    return useGetModels<Entities.VersionHistory>(parameter, "versionHistories");
};
export const useGetVersionHistory = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.VersionHistory>(id, parameter, "versionHistories");
};
export const useUpdateVersionHistory = () => {
    return useUpdateModel<Entities.VersionHistory>("versionHistories");
};
export const useDeleteVersionHistory = () => {
    return useDeleteModel<Entities.VersionHistory>("versionHistories");
};
export const useGetVersionHistoryActions = (parameter?: ODataParameter) => {
    return useGetModels<Entities.VersionHistoryAction>(parameter, "versionHistoryActions");
};
export const useGetVersionHistoryAction = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.VersionHistoryAction>(id, parameter, "versionHistoryActions");
};
export const useUpdateVersionHistoryAction = () => {
    return useUpdateModel<Entities.VersionHistoryAction>("versionHistoryActions");
};
export const useDeleteVersionHistoryAction = () => {
    return useDeleteModel<Entities.VersionHistoryAction>("versionHistoryActions");
};
export const useGetVmiBins = (parameter?: ODataParameter) => {
    return useGetModels<Entities.VmiBin>(parameter, "vmiBins");
};
export const useGetVmiBin = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.VmiBin>(id, parameter, "vmiBins");
};
export const useUpdateVmiBin = () => {
    return useUpdateModel<Entities.VmiBin>("vmiBins");
};
export const useDeleteVmiBin = () => {
    return useDeleteModel<Entities.VmiBin>("vmiBins");
};
export const useGetVmiCounts = (parameter?: ODataParameter) => {
    return useGetModels<Entities.VmiCount>(parameter, "vmiCounts");
};
export const useGetVmiCount = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.VmiCount>(id, parameter, "vmiCounts");
};
export const useUpdateVmiCount = () => {
    return useUpdateModel<Entities.VmiCount>("vmiCounts");
};
export const useDeleteVmiCount = () => {
    return useDeleteModel<Entities.VmiCount>("vmiCounts");
};
export const useGetVmiLocations = (parameter?: ODataParameter) => {
    return useGetModels<Entities.VmiLocation>(parameter, "vmiLocations");
};
export const useGetVmiLocation = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.VmiLocation>(id, parameter, "vmiLocations");
};
export const useUpdateVmiLocation = () => {
    return useUpdateModel<Entities.VmiLocation>("vmiLocations");
};
export const useDeleteVmiLocation = () => {
    return useDeleteModel<Entities.VmiLocation>("vmiLocations");
};
export const useGetVmiNotes = (parameter?: ODataParameter) => {
    return useGetModels<Entities.VmiNote>(parameter, "vmiNotes");
};
export const useGetVmiNote = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.VmiNote>(id, parameter, "vmiNotes");
};
export const useUpdateVmiNote = () => {
    return useUpdateModel<Entities.VmiNote>("vmiNotes");
};
export const useDeleteVmiNote = () => {
    return useDeleteModel<Entities.VmiNote>("vmiNotes");
};
export const useGetWarehouses = (parameter?: ODataParameter) => {
    return useGetModels<Entities.Warehouse>(parameter, "warehouses");
};
export const useGetWarehouse = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.Warehouse>(id, parameter, "warehouses");
};
export const useUpdateWarehouse = () => {
    return useUpdateModel<Entities.Warehouse>("warehouses");
};
export const useDeleteWarehouse = () => {
    return useDeleteModel<Entities.Warehouse>("warehouses");
};
export const useGetWarehouseWebsites = (parameter?: ODataParameter) => {
    return useGetModels<Entities.WarehouseWebsite>(parameter, "warehouseWebsites");
};
export const useGetWarehouseWebsite = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.WarehouseWebsite>(id, parameter, "warehouseWebsites");
};
export const useUpdateWarehouseWebsite = () => {
    return useUpdateModel<Entities.WarehouseWebsite>("warehouseWebsites");
};
export const useDeleteWarehouseWebsite = () => {
    return useDeleteModel<Entities.WarehouseWebsite>("warehouseWebsites");
};
export const useGetWebPages = (parameter?: ODataParameter) => {
    return useGetModels<Entities.WebPage>(parameter, "webPages");
};
export const useGetWebPage = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.WebPage>(id, parameter, "webPages");
};
export const useUpdateWebPage = () => {
    return useUpdateModel<Entities.WebPage>("webPages");
};
export const useDeleteWebPage = () => {
    return useDeleteModel<Entities.WebPage>("webPages");
};
export const useGetWebPageContents = (parameter?: ODataParameter) => {
    return useGetModels<Entities.WebPageContent>(parameter, "webPageContents");
};
export const useGetWebPageContent = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.WebPageContent>(id, parameter, "webPageContents");
};
export const useUpdateWebPageContent = () => {
    return useUpdateModel<Entities.WebPageContent>("webPageContents");
};
export const useDeleteWebPageContent = () => {
    return useDeleteModel<Entities.WebPageContent>("webPageContents");
};
export const useGetWebsites = (parameter?: ODataParameter) => {
    return useGetModels<Entities.Website>(parameter, "websites");
};
export const useGetWebsite = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.Website>(id, parameter, "websites");
};
export const useUpdateWebsite = () => {
    return useUpdateModel<Entities.Website>("websites");
};
export const useDeleteWebsite = () => {
    return useDeleteModel<Entities.Website>("websites");
};
export const useGetWebsiteAllowedCustomers = (parameter?: ODataParameter) => {
    return useGetModels<Entities.WebsiteAllowedCustomer>(parameter, "websiteAllowedCustomers");
};
export const useGetWebsiteAllowedCustomer = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.WebsiteAllowedCustomer>(id, parameter, "websiteAllowedCustomers");
};
export const useUpdateWebsiteAllowedCustomer = () => {
    return useUpdateModel<Entities.WebsiteAllowedCustomer>("websiteAllowedCustomers");
};
export const useDeleteWebsiteAllowedCustomer = () => {
    return useDeleteModel<Entities.WebsiteAllowedCustomer>("websiteAllowedCustomers");
};
export const useGetWebsiteCarriers = (parameter?: ODataParameter) => {
    return useGetModels<Entities.WebsiteCarrier>(parameter, "websiteCarriers");
};
export const useGetWebsiteCarrier = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.WebsiteCarrier>(id, parameter, "websiteCarriers");
};
export const useUpdateWebsiteCarrier = () => {
    return useUpdateModel<Entities.WebsiteCarrier>("websiteCarriers");
};
export const useDeleteWebsiteCarrier = () => {
    return useDeleteModel<Entities.WebsiteCarrier>("websiteCarriers");
};
export const useGetWebsiteCountries = (parameter?: ODataParameter) => {
    return useGetModels<Entities.WebsiteCountry>(parameter, "websiteCountries");
};
export const useGetWebsiteCountry = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.WebsiteCountry>(id, parameter, "websiteCountries");
};
export const useUpdateWebsiteCountry = () => {
    return useUpdateModel<Entities.WebsiteCountry>("websiteCountries");
};
export const useDeleteWebsiteCountry = () => {
    return useDeleteModel<Entities.WebsiteCountry>("websiteCountries");
};
export const useGetWebsiteCurrencies = (parameter?: ODataParameter) => {
    return useGetModels<Entities.WebsiteCurrency>(parameter, "websiteCurrencies");
};
export const useGetWebsiteCurrency = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.WebsiteCurrency>(id, parameter, "websiteCurrencies");
};
export const useUpdateWebsiteCurrency = () => {
    return useUpdateModel<Entities.WebsiteCurrency>("websiteCurrencies");
};
export const useDeleteWebsiteCurrency = () => {
    return useDeleteModel<Entities.WebsiteCurrency>("websiteCurrencies");
};
export const useGetWebsiteDealers = (parameter?: ODataParameter) => {
    return useGetModels<Entities.WebsiteDealer>(parameter, "websiteDealers");
};
export const useGetWebsiteDealer = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.WebsiteDealer>(id, parameter, "websiteDealers");
};
export const useUpdateWebsiteDealer = () => {
    return useUpdateModel<Entities.WebsiteDealer>("websiteDealers");
};
export const useDeleteWebsiteDealer = () => {
    return useDeleteModel<Entities.WebsiteDealer>("websiteDealers");
};
export const useGetWebsiteLanguages = (parameter?: ODataParameter) => {
    return useGetModels<Entities.WebsiteLanguage>(parameter, "websiteLanguages");
};
export const useGetWebsiteLanguage = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.WebsiteLanguage>(id, parameter, "websiteLanguages");
};
export const useUpdateWebsiteLanguage = () => {
    return useUpdateModel<Entities.WebsiteLanguage>("websiteLanguages");
};
export const useDeleteWebsiteLanguage = () => {
    return useDeleteModel<Entities.WebsiteLanguage>("websiteLanguages");
};
export const useGetWebsiteProductCrossSells = (parameter?: ODataParameter) => {
    return useGetModels<Entities.WebsiteProductCrossSell>(parameter, "websiteProductCrossSells");
};
export const useGetWebsiteProductCrossSell = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.WebsiteProductCrossSell>(id, parameter, "websiteProductCrossSells");
};
export const useUpdateWebsiteProductCrossSell = () => {
    return useUpdateModel<Entities.WebsiteProductCrossSell>("websiteProductCrossSells");
};
export const useDeleteWebsiteProductCrossSell = () => {
    return useDeleteModel<Entities.WebsiteProductCrossSell>("websiteProductCrossSells");
};
export const useGetWebsitePromotions = (parameter?: ODataParameter) => {
    return useGetModels<Entities.WebsitePromotion>(parameter, "websitePromotions");
};
export const useGetWebsitePromotion = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.WebsitePromotion>(id, parameter, "websitePromotions");
};
export const useUpdateWebsitePromotion = () => {
    return useUpdateModel<Entities.WebsitePromotion>("websitePromotions");
};
export const useDeleteWebsitePromotion = () => {
    return useDeleteModel<Entities.WebsitePromotion>("websitePromotions");
};
export const useGetWebsiteSitemaps = (parameter?: ODataParameter) => {
    return useGetModels<Entities.WebsiteSitemap>(parameter, "websiteSitemaps");
};
export const useGetWebsiteSitemap = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.WebsiteSitemap>(id, parameter, "websiteSitemaps");
};
export const useUpdateWebsiteSitemap = () => {
    return useUpdateModel<Entities.WebsiteSitemap>("websiteSitemaps");
};
export const useDeleteWebsiteSitemap = () => {
    return useDeleteModel<Entities.WebsiteSitemap>("websiteSitemaps");
};
export const useGetWebsiteStates = (parameter?: ODataParameter) => {
    return useGetModels<Entities.WebsiteState>(parameter, "websiteStates");
};
export const useGetWebsiteState = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.WebsiteState>(id, parameter, "websiteStates");
};
export const useUpdateWebsiteState = () => {
    return useUpdateModel<Entities.WebsiteState>("websiteStates");
};
export const useDeleteWebsiteState = () => {
    return useDeleteModel<Entities.WebsiteState>("websiteStates");
};
export const useGetWishLists = (parameter?: ODataParameter) => {
    return useGetModels<Entities.WishList>(parameter, "wishLists");
};
export const useGetWishList = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.WishList>(id, parameter, "wishLists");
};
export const useUpdateWishList = () => {
    return useUpdateModel<Entities.WishList>("wishLists");
};
export const useDeleteWishList = () => {
    return useDeleteModel<Entities.WishList>("wishLists");
};
export const useGetWishListCustomers = (parameter?: ODataParameter) => {
    return useGetModels<Entities.WishListCustomer>(parameter, "wishListCustomers");
};
export const useGetWishListCustomer = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.WishListCustomer>(id, parameter, "wishListCustomers");
};
export const useUpdateWishListCustomer = () => {
    return useUpdateModel<Entities.WishListCustomer>("wishListCustomers");
};
export const useDeleteWishListCustomer = () => {
    return useDeleteModel<Entities.WishListCustomer>("wishListCustomers");
};
export const useGetWishListEmailSchedules = (parameter?: ODataParameter) => {
    return useGetModels<Entities.WishListEmailSchedule>(parameter, "wishListEmailSchedules");
};
export const useGetWishListEmailSchedule = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.WishListEmailSchedule>(id, parameter, "wishListEmailSchedules");
};
export const useUpdateWishListEmailSchedule = () => {
    return useUpdateModel<Entities.WishListEmailSchedule>("wishListEmailSchedules");
};
export const useDeleteWishListEmailSchedule = () => {
    return useDeleteModel<Entities.WishListEmailSchedule>("wishListEmailSchedules");
};
export const useGetWishListProducts = (parameter?: ODataParameter) => {
    return useGetModels<Entities.WishListProduct>(parameter, "wishListProducts");
};
export const useGetWishListProduct = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.WishListProduct>(id, parameter, "wishListProducts");
};
export const useUpdateWishListProduct = () => {
    return useUpdateModel<Entities.WishListProduct>("wishListProducts");
};
export const useDeleteWishListProduct = () => {
    return useDeleteModel<Entities.WishListProduct>("wishListProducts");
};
export const useGetWishListShares = (parameter?: ODataParameter) => {
    return useGetModels<Entities.WishListShare>(parameter, "wishListShares");
};
export const useGetWishListShare = (id: string, parameter?: ODataParameter) => {
    return useGetModel<Entities.WishListShare>(id, parameter, "wishListShares");
};
export const useUpdateWishListShare = () => {
    return useUpdateModel<Entities.WishListShare>("wishListShares");
};
export const useDeleteWishListShare = () => {
    return useDeleteModel<Entities.WishListShare>("wishListShares");
};
